// import library
import React from "react";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router";
import { useContext, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import moment from "moment";
// import files
import { env } from "../../env";
import { AuthContext } from "../../context";
import { logEvent } from "../../analytics";
// common components
import Layout from "../../layouts/Layout";
import Pagination from "../../components/Common/Table/Pagination";
import AddQuantityButton from "../../components/Common/Table/AddQuantityButton";
import RemoveQuantityButton from "../../components/Common/Table/RemoveQuantityButton";
import SortItem from "../../components/Common/Order/SortItem";
import DateInputField from "../../components/Common/InputField/DateInputField";
import LoaderIcon from "../../components/Common/Icon/Loader";
import SearchBar from "../../components/Common/Table/SearchBar";
import SortData from "../../components/Common/Table/SortData";
import FilterFormLayout from "../../components/Common/Table/FilterFormLayout";
import TableLoaderIcon from "../../components/Common/Icon/TableLoader";
import CartBox from "../../components/Common/CreateOrder/CartBox";
import VirtualCartBox from "../../components/Common/CreateOrder/VirtualCart";
import MessageLink from "../../components/Common/Table/MessageLink";
import CategoryCheckbox from "../../components/Common/InputField/CategoryCheckbox";
import ProductGroupCheckbox from "../../components/Common/InputField/ProductGroupCheckbox";
import FilterDataHover from "../../components/Common/Table/FilterDataHover";
import MobilePagination from "../../components/Common/Table/MobilePagination";
import CategorySubcategoryFilter from "../../components/Common/CreateOrder/CategorySubcategoryFilter";
import { NavLink } from "react-router-dom";
import CustomerFormModal from "../../components/Common/CreateOrder/CustomerFormModal";
import TransportationDropdown from "../../components/Common/CreateOrder/TransportationDropdown";
import DeliveryAddressDropdown from "../../components/Common/CreateOrder/DeliveryAddressDropDown";
import CartLoaderIcon from "../../components/Common/Icon/CartLoader";

const OrderAgain = () => {
    // variables
    const { t } = useTranslation();
    const navigate = useNavigate();
    const today = dayjs();
    const authContext = useContext(AuthContext);
    const dropdownRef = useRef(null);
    const dropdownRef1 = useRef(null);
    const dropdownRef2 = useRef(null);
    const dropdownRef3 = useRef(null);
    const {id, customerid} = useParams();
    const baseUrl = env.REACT_APP_API_URL;
    const token = localStorage.getItem('token');

    // local store
    const coTab = localStorage.getItem('co_tab');
    const coCoupon = localStorage.getItem('co_coupon');
    const coComment = localStorage.getItem('co_comment');
    const coMethod = localStorage.getItem('co_method');
    const coId = localStorage.getItem('co_id');
    const coQuantity = localStorage.getItem('co_quantity') ? JSON.parse(localStorage.getItem('co_quantity')) : [];
    const coQtyMessage = localStorage.getItem('co_qty_message') ? JSON.parse(localStorage.getItem('co_qty_message')) : [];
    const coItems = localStorage.getItem('co_items') ? JSON.parse(localStorage.getItem('co_items')) : [];
    const coCalculateJson = localStorage.getItem('co_calculate_json') ? JSON.parse(localStorage.getItem('co_calculate_json')) : [];
    const coCalculate = localStorage.getItem('co_calculate') ? JSON.parse(localStorage.getItem('co_calculate')) : [];
    const coCalculateFilter = localStorage.getItem('co_calculate_filter') ? JSON.parse(localStorage.getItem('co_calculate_filter')) : [];
    const coCode = localStorage.getItem('co_code') ? JSON.parse(localStorage.getItem('co_code')) : [];
    const coCustomer = localStorage.getItem('co_customer');
    const coCalculateButton = localStorage.getItem('co_calculate_button');
    // loader
    const [isLoader, setIsLoader] = useState(true);
    const [isTableLoader, setIsTableLoader] = useState(false);
    const [isMadeForYouLoader, setIsMadeForYouLoader] = useState(false);
    const [isCommonTableLoader, setIsCommonTableLoader] = useState(false);
    // static data
    const activeTab = "border-b border-blue-normal text-blue-normal";
    const weekDaysGr = ['Σάββατο', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο'];
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    const sortTypesList = [
        {
            "name" : "product name - top to bottom",
            "field" : "productname",
            "type" : "asc"
        },
        {
            "name" : "product name - bottom to top",
            "field" : "productname",
            "type" : "desc"
        },
        {
            "name" : "product code - top to bottom",
            "field" : "code",
            "type" : "asc"
        },
        {
            "name" : "product code - bottom to top",
            "field" : "code",
            "type" : "desc"
        },
        {
            "name" : "product price - top to bottom",
            "field" : "price",
            "type" : "asc"
        },
        {
            "name" : "product price - bottom to top",
            "field" : "price",
            "type" : "desc"
        },
        {
            "name" : "product m/m - top to bottom",
            "field" : "unit",
            "type" : "asc"
        },
        {
            "name" : "product m/m - bottom to top",
            "field" : "unit",
            "type" : "desc"
        },
    ];
    const [inputs, setInputs] = useState({
        orderSeries: 1,
        orderSeriesLastNumber: 0,
        orderSeriesDescription : "Πώληση Ροής",
        productTypeDescription : "all",
        productTypeId: 0,
        couponCode: coCoupon ? coCoupon : "",
        items: coItems ? coItems : [],
        filteredItems: coItems ? coItems : []
    });
    const [filterInputsOne, setFilterInputsOne] = useState({
        productCode: "",
        description: "",
        categoryIdArray: "",
        categoryNameArray: "",
        productGroupIdArray: "",
        productGroupNameArray: "",
    });
    const [filterInputsTwo, setFilterInputsTwo] = useState({
        productCode: "",
        description: "",
        categoryIdArray: "",
        categoryNameArray: "",
        productGroupIdArray: "",
        productGroupNameArray: "",
    });
    // data
    const [comment, setComment] = useState(coComment ? coComment : "");
    const [showTab, setShowTab] = useState(coTab ? coTab : 'cart');
    const [filterSelectedData, setFilterSelectedData] = useState("");
    const [subcatIds, setSubcatIds] = useState("");
    const [workingDays, setWorkingDays] = useState([]);
    const [showWarning, setShowWarning] = useState(false);
    const [navigateLink, setNavigateLink] = useState(null);
    // store data
    const [defaultProductImage, setDefaultProductImage] = useState("");
    const [customerData, setCustomerData] = useState({});
    const [categoryListOne, setCategoryListOne] = useState([]);
    const [productGroupList, setProductGroupList] = useState([]);
    const [categoryListTwo, setCategoryListTwo] = useState([]);
    const [filterCategoryList, setFilterCategoryList] = useState([]);
    const [madeForYouSectionList, setMadeForYouSectionList] = useState([]);
    const [calculateApiCart, setCalculateApiCart] = useState(coCalculate ? coCalculate : []);
    const [productStaticQuantity, setProductStaticQuantity] = useState(coQuantity ? coQuantity : []);
    const [productStaticMessage, setProductStaticMessage] = useState(coQtyMessage ? coQtyMessage : []);
    const [orderSeries, setOrderSeries] = useState([]);
    const [disbaleWeeks, setDisableWeeks] = useState([]);
    const [currentDate, setCurrentDate] = useState(today);
    const [ipData, setIpData] = useState({});
    
    const [commonItems, setCommonItems] = useState({
        "total_record": 0,
        "totalpages": 0,
        "list": []
    });
    const [products, setProducts] = useState({
        "total_record": 0,
        "totalpages": 0,
        "list": []
    });

    // handle
    const [calculateButton, setCalculateButton] = useState(coCalculateButton ? coCalculateButton : false);
    const [showSortOne, setShowSortOne] = useState(false);
    const [showCategoryOne, setShowCategoryOne] = useState(false);
    const [showProductGroupOne, setShowProductGroupOne] = useState(false);
    const [showFilterOne, setShowFilterOne] = useState(false);
    const [showFilterTwo, setShowFilterTwo] = useState(false);
    const [showCategoryTwo, setShowCategoryTwo] = useState(false);
    const [showProductGroupTwo, setShowProductGroupTwo] = useState(false);
    const [showSortTwo, setShowSortTwo] = useState(false);
    const [showPaymentMethod, setShowPaymentMethod] = useState(false);
    const [showTransportation, setShowTransportation] = useState(false);
    const [showCalculating, setShowCalculating] = useState(false);
    const [formButton, setFormButton] = useState(false);
    const [isCalculate, setIsCalculate] =  useState(false);
    const [reCalculate, setReCalculate] = useState(coCalculateButton ? coCalculateButton : false);
    const [showBundleModal, setShowBundleModal] = useState(false);
    const [isBundleLoading, setIsBundleLoading] = useState(0);
    const [showDeliveryFormModal, setShowDeliveryFormModal] = useState(false);
    const [showTransportationFormModal, setShowTransportationFormModal] = useState(false);
    const [isCompanyChecked, setIsCompanyChecked] = useState(false);
    const [isAddressChecked, setIsAddressChecked] = useState(false);
    const [isCartLoader, setIsCartLoader] = useState(false);

    // table
    const [rowCurrentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(30);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortField, setSortField] = useState("");
    const [sortType, setSortType] = useState("");
    const [sortName, setSortName] = useState("");
    const [rowCommonItemsCurrentPage, setCommonItemsCurrentPage] = useState(1);
    const [rowsCommonItemsPerPage, setCommonItemsRowsPerPage] = useState(30);
    const [searchCommonItemsTerm, setSearchCommonItemsTerm] = useState("");
    const [sortCommonItemsField, setCommonItemsSortField] = useState("");
    const [sortCommonItemsType, setCommonItemsSortType] = useState("");
    const [sortCommonItemsName, setCommonItemsSortName] = useState("");
    // other
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState(coMethod ? coMethod : '');
    const [transportationList, setTransportationList] = useState([]);
    const [paymentTypeId, setPaymentTypeId] = useState(coId ? coId : "");
    const [deliveryDate, setDeliveryDate] = useState("");
    const [defaultDeliveryDate, setDefaultDeliveryDate] = useState("");
    const [calculateJson, setCalculateJson] = useState(coCalculateJson ? coCalculateJson :[]);
    const [cartProductCode, setCartProductCode] = useState(coCode ? coCode : []);
    const [calculatedItems, setCalculateItems] = useState(coCalculateFilter ? coCalculateFilter : []);
    const [filterCalculateItems , setFilterCalculateItems] = useState(coCalculateFilter ? coCalculateFilter : []);
    const [bundleProducts, setBundleProducts] = useState([]);
    const [mainProduct, setMainProduct] = useState({});
    const [deliveryAddressList, setDeliveryAddressList] = useState([]);
    const [personId, setPersonId] = useState(0);
    const [personName, setPersonName] = useState("");
    const [transportationCompanyId, setTransportationCompanyId] = useState(0);
    const [transportationCompanyName, setTransportationCompanyName] = useState("");
    const [shippingCost, setShippingCost] = useState(0);
    const [uniqueKey, setUniqueKey] = useState('');
    const [cartId, setCartId] = useState('');

    // bundle variable
    const [selectedItems, setSelectedItems] = useState([]);
    // cart
    const [cartItemsData, setCartItemsData] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "totalPoints" : 0,
        "totalInitialPrice" : 0,
    });
    const [virtualCartItems, setVirtualCartItems] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "netAmount" : 0,
        "vats" : 0,
        "totalAmount" : 0,
        "discountPercentage" : 0,
        "discountAmount" : 0,
        "finalAmount" : 0,
        "totalTaxes": 0
    });
    const [calculateCartItems, setCalculateCartItems] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "netAmount" : 0,
        "vats" : 0,
        "totalAmount" : 0,
        "discountPercentage" : 0,
        "discountAmount" : 0,
        "finalAmount" : 0,
        "totalTaxes": 0
    });
    const [finalCartItems, setFinalCartItems] = useState({
        "itemsCount" : 0,
        "totalQuantity" : 0,
        "netAmount" : 0,
        "vats" : 0,
        "totalAmount" : 0,
        "discount" : 0,
        "transportationFee" : 0,
        "totalPoints" : 0,
        "discountPercentage" : 0,
        "discountAmount" : 0,
        "finalAmount" : 0,
        "totalTaxes": 0
    });

    const handlePageChange = () => { 
        if (inputs?.items?.length > 0) {
            Swal.fire({
                title: `${t("are you sure")}?`,
                text: `${t("if you click yes, you will lose all the data of the order, the cart will be empty")}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `${t('yes')}`,
                cancelButtonText: `${t('no')}`
            }).then((result) => {
                if (result.isConfirmed) {
                    clearCartStorage();
                    navigate('/order/history');
                } else {
                    window.history.pushState(null, "", window.location.pathname); // Stay on page
                }
            });
            return;
        }
    
        navigate('/order/history');
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowCategoryOne(false);
                setShowProductGroupOne(false);
                setShowFilterOne(false);
                setShowFilterTwo(false);
                setShowCategoryTwo(false);
                setShowProductGroupTwo(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
                setShowPaymentMethod(false)
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef2.current && !dropdownRef2.current.contains(event.target)) {
                setShowTransportation(false)
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef3.current && !dropdownRef3.current.contains(event.target)) {
                setShowSortOne(false);
                setShowSortTwo(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const handlePopState = () => {
            window.history.pushState(null, "", window.location.pathname); // Prevent direct back navigation
            handlePageChange(); // Call function to handle logic
        };
    
        window.history.pushState(null, "", window.location.pathname); // Set initial state
        window.addEventListener("popstate", handlePopState);
    
        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [inputs]);
        
    // functions
    useEffect(() => {
        const requestDataOne = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": rowCommonItemsCurrentPage,
            "recordLimit": rowsCommonItemsPerPage,
            "searchtext": searchCommonItemsTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": filterInputsOne.productCode,
            "product_desc_search": filterInputsOne.description,
            "groupa": filterInputsOne.productGroupIdArray,
            "categoryids": filterInputsOne.categoryIdArray
        }; 
        const requestDataTwo = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": rowCurrentPage,
            "recordLimit": rowsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": inputs.productTypeId,
            "product_code_search": filterInputsTwo.productCode,
            "product_desc_search": filterInputsTwo.description,
            "groupa": filterInputsTwo.productGroupIdArray,
            "categoryids": filterInputsTwo.categoryIdArray,
            "subcategoryids": subcatIds
        }; 
    
        const fetchData = async () => {
            try {
                if (id) {
                    if (coCustomer !== id) {
                        clearCartStorage();
                    }
    
                    await Promise.all([
                        getOrderData(baseUrl, token),
                        getCustomerDataApi(baseUrl, token),
                        getDefaultProductImage(baseUrl, token),
                        getCompanyErpRelationsList(baseUrl, token),
                        getCategoryList(baseUrl, token, inputs.productTypeId),
                        getProductGroupA(baseUrl, token),
                        getPaymentTypeList(baseUrl, token),
                        getDeliveryWeeks(baseUrl, token),
                        getCustomerDeliveryAddresses(baseUrl, token),
                        getTransportationCompanyList(baseUrl, token),
                        calculateSummary(coItems),
                        finalCalculateSummary(coCalculate),
                    ]);
    
                    setIsLoader(false);
                    if(showTab === 'summary') {
                        setShippingCost(localStorage.getItem("co_shipping"));
                    }
                    await getCommonItems(baseUrl, token, requestDataOne);
                    await getMadeForYouSectionList(baseUrl, token);
                    await getProductListApi(baseUrl, token, requestDataTwo);
                }
            } catch (error) {
                setIsLoader(false); // Stop loader even if error occurs
                console.error("Error fetching data", error);
            }
        };
        fetchData();

    }, [id, coCustomer, baseUrl, token]);
    const workingDaysString = workingDays.join(", ");

    // api's
    const getOrderData = async (url, token) => {
        const headers = {
            "Accept": "Application/json",
            "Content-Type": "Application/json",
            "Authorization": `Bearer ${token}`
        };
    
        try {
            // Fetch customer order details
            const response = await axios.get(`${url}/api/Product/GetCustomerOrderDetail?orderid=${id}`, { headers });
    
            if (!response.data.success) {
                const itemsArray = [];
                let linenum = 1;
                let calculateArrayJson = [];
                let productCodeArray = [];
                let staticQuantityArray = {};
                let staticMessageArray = {};
    
                // Process each product in the order details
                for (const value of response.data.details) {
                    if (!value.iscalculateditem) {
                        try {
                            // Fetch product details
                            const productResponse = await axios.get(`${baseUrl}/api/Product/GetProductDetail?productid=${value.productid}&customerid=${response.data.customerID}`, { headers });
                            if (productResponse.data[0]) {
                                const array = {
                                    "action": "add",
                                    "id": value.productid,
                                    "message": "",
                                    "product": productResponse.data[0],
                                    "quantity": value.qty,
                                    "suggestQty": ""
                                };
    
                                // Get extra taxes asynchronously
                                const taxResponse = await getProductExtraTaxes(value.productid);
                                const extraTaxes = taxResponse?.nettaxvalue;
                                array.product.extra_taxes = extraTaxes || (value?.extra_taxes || 0) / value.qty;
    
                                // Add the product to the items array
                                itemsArray.push(array);
    
                                const productLines = {
                                    "LINENUM": linenum,
                                    "vat_code": productResponse.data[0].vat_code || 0,
                                    "MU": productResponse.data[0].baseUnitOfMeasure || "",
                                    "item_code": productResponse.data[0].item_code,
                                    "QTY1": value.qty,
                                    "UnitPrice": productResponse.data[0].productprice || 0,
                                    "discount_pct": productResponse.data[0].discount || 0,
                                    "product_name": productResponse.data[0].productname,
                                    "vat_percent": productResponse.data[0].vat_percentage || 0
                                };
    
                                linenum++;
                                calculateArrayJson.push(productLines);
                                productCodeArray.push(value.product_code);
                                staticQuantityArray[value.product_code] = value.qty;
                                staticMessageArray[value.product_code] = "";
                            }
                        } catch (error) {
                            console.log("Error fetching product data:", error);
                        }
                    }
                }
    
                // Update state after all items are processed
                setInputs({
                    ...inputs,
                    'items': itemsArray,
                    'filteredItems': itemsArray
                });
                setProductStaticQuantity(staticQuantityArray);
                setProductStaticMessage(staticMessageArray);
                setCartProductCode(productCodeArray);
                setCalculateJson(calculateArrayJson);
                calculateSummary(itemsArray);
            } else {
                Swal.fire({
                    title: `${t("warning")}!`,
                    text: `${t("something went wrong")}!`,
                    icon: "warning",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "ok"
                });
                navigate('/order/history');
            }
        } catch (error) {
            console.log("Error fetching order data:", error);
            if (error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        }
    };
    // same as create
    const getOrderSeriesList = async (url, token, partnerid) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Customer/GetOrderSeriesListsPartnerWise?partnerid=${partnerid}`, { headers })
        .then((response) => {
            if(response.data && response.data.success !== '0') {
                setOrderSeries(response.data);
                response.data.map((value, index) => {
                    if(value.orderseriesid == 1) {
                        setInputs({
                            ...inputs,
                            orderSeriesLastNumber : value.orderseries_lastnumber,
                        });
                    }
                });
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getIpJson = async () => {
        axios.get("https://ipapi.co/json/", { headers : {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
        }})
        .then((response) => {
            setIpData(response.data);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getCustomerDataApi = async (url, token) => {
        axios.post(url + "/api/Customer/GetCustomerDetail", { customerid: customerid }, {
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            if (response.data.length > 0) {
                const momentCurrentDate = moment();
                axios.get(baseUrl+`/api/Customer/GetCustomerDeliveryWorkingHoursData?customerid=${customerid}`, { headers : {
                    "Accept" : "Application/json",
                    "Content-Type" : "Application/json",
                    "Authorization" : `Bearer ${token}`
                }})
                .then((response1) => {
                    if(response1.data.data.week) {
                        const inputTime = response1.data.data.time;
                        const inputWeek = response1.data.data.week;
                        const dayNumber = momentCurrentDate.day();

                        if (inputWeek.includes(7)) {
                            inputWeek[inputWeek.indexOf(7)] = 0;
                        }

                        const localizedWorkingDays = inputWeek.map(day => weekDaysGr[day]);
                        setWorkingDays(localizedWorkingDays);

                        if (inputWeek.includes(dayNumber)) {
                            const d1 = momentCurrentDate.format("YYYY-MM-DD HH:mm:ss");
                            if(inputTime) {
                                const formattedInputTime = convertTo24HourFormat(inputTime);
                                var d2 = momentCurrentDate.format(`YYYY-MM-DD ${formattedInputTime}`);
                            } else {
                                var d2 = momentCurrentDate.format(`YYYY-MM-DD 04:00:00`);
                            }

                            if (moment(d1).isAfter(d2)) {
                                for (let i = 1; i <= 7; i++) {
                                    const newDate = moment().clone().add(i, "days");
                                    if (inputWeek.includes(newDate.day())) {
                                        setCurrentDate(today.add(1, 'day'));
                                        setDeliveryDate(newDate.format("YYYY-MM-DD"));
                                        setDefaultDeliveryDate(newDate.format("YYYY-MM-DD"));
                                        break;
                                    }
                                }
                            } else {
                                setCurrentDate(today);
                                setDeliveryDate(momentCurrentDate.format("YYYY-MM-DD"));
                                setDefaultDeliveryDate(momentCurrentDate.format("YYYY-MM-DD"));
                            }
                        } else {
                            for (let i = 1; i <= 7; i++) {
                                const newDate = moment().clone().add(i, "days");
                                if (inputWeek.includes(newDate.day())) {
                                    setCurrentDate(today.add(1, 'day'));
                                    setDeliveryDate(newDate.format("YYYY-MM-DD"));
                                    setDefaultDeliveryDate(newDate.format("YYYY-MM-DD"));
                                    break;
                                }
                            }
                        }
                    } else {
                        const inputWeek = [1, 2, 3, 4, 5, 6];
                        const localizedWorkingDays = inputWeek.map(day => weekDaysGr[day]);
                        setWorkingDays(localizedWorkingDays);
                        var d1 = momentCurrentDate.format("YYYY-MM-DD HH:mm:ss");
                        var d2 = momentCurrentDate.format(`YYYY-MM-DD 04:00:00`);
                        if (moment(d1).isAfter(d2)) {
                            const newDate = momentCurrentDate.add(1, "days");
                            setCurrentDate(today.add(1, 'day'));
                            setDeliveryDate(newDate.format("YYYY-MM-DD"));
                            setDefaultDeliveryDate(newDate.format("YYYY-MM-DD"));
                        } else {
                            setCurrentDate(today);
                            setDeliveryDate(momentCurrentDate.format("YYYY-MM-DD"));
                            setDefaultDeliveryDate(momentCurrentDate.format("YYYY-MM-DD"));
                        }
                    }
                }).catch((error) => {
                    console.log(error);
                });
                
                setCustomerData(response.data[0]);
                setPaymentMethod(response.data[0].paymenttype);
                setPaymentTypeId(response.data[0].paymenttypeid);

                getOrderSeriesList(baseUrl, token, response.data[0].partnerid);
                getIpJson();

                // if(!localStorage.getItem('co_tab') && response.data[0].showcommon) {
                //     setShowTab('common-items')
                // }
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        })
    };
    const getDefaultProductImage = async (url, token) => {
            const headers = {
                "Accept" : "Application/json",
                "Content-Type" : "Application/json",
                "Authorization" : `Bearer ${token}`
            };
    
            await axios.get(url+"/api/User/GetDefaultImage",{ headers })
            .then((response) => {
                setDefaultProductImage(response.data.productDefaultImage);
            }).catch((error) => {
                console.log(error);
                if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                    localStorage.removeItem("token");
                    localStorage.removeItem("userInfo");
                    window.location.reload();
                }
            });
    };
    const getCompanyErpRelationsList = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/OfflineSync/GetCompanyErpRelationsList", { headers })
        .then((response) => {
            if(response.data.length > 0 && response.data[0].iscalculationmandatory) {
                if(response.data[0].iscalculationmandatory === "1") {
                    setIsCalculate(true);
                } else {
                    setIsCalculate(false);
                    setCalculateButton(true);
                }
            } else {
                setCalculateButton(true);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getCategoryList = async (url, token, productId) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/GetProductCategoryList?customerid=${customerid}&producttypeid=0`, { headers })
        .then((response) => {
            if(response.data && response.data.success !== '0') {
                setCategoryListOne(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });

        await axios.get(url+`/api/Product/GetProductCategoryList?customerid=${customerid}&producttypeid=${productId}`, { headers })
        .then((response) => {
            if(response.data && response.data.success !== '0') {
                setCategoryListTwo(response.data);
            }
            axios.get(url+`/api/OfflineSync/GetProductSubCategories`, { headers })
            .then((response1) => {
                if(response.data && response.data.success !== '0') {
                    const categorizedData = response.data.map(category => ({
                        ...category,
                        subcategories: response1.data
                            .filter(sub => sub.categoryid === category.categoryid)
                            .map(({ subcategoryid, subcategoryname, ordering }) => ({
                                subcategoryid, subcategoryname, ordering
                            }))
                    }));
                    setFilterCategoryList(categorizedData);
                }
            }).catch((error) => {
                console.log(error);
            })
        }).catch((error) => {
            console.log(error);
        });
    };
    const getProductGroupA = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/OfflineSync/GetProductGroupAList`, { headers })
        .then((response) => {
            setProductGroupList(response.data);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getPaymentTypeList = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/GetPaymentTypeListForB2B?customerid=${customerid}`, { headers })
        .then((response) => {
            setPaymentMethods(response.data);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getDeliveryWeeks = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Customer/GetCustomerDeliveryWorkingHoursData?customerid=${customerid}`, { headers })
        .then((response) => {
            if(response.data.data.week) {
                const week = [1, 2, 3, 4, 5, 6, 7];
                const disableWeek = [];
                week.map((value) => {
                    if(!response.data.data.week.includes(value)) {
                        disableWeek.push(value);
                    }
                });

                if(disableWeek.includes(7)) {
                    disableWeek.map((value, index) => {
                        if(value === 7) {
                            disableWeek[index] = 0;
                        }
                    })
                }
                setDisableWeeks(disableWeek);
            } else {
                setDisableWeeks([0]); 
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getCommonItems = async (url, token, data) => {
        setIsCommonTableLoader(true);
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(url+`/api/Product/GetCommonItemsList`, data, { headers })
        .then((response) => {
            setCommonItems(response.data);
            setIsCommonTableLoader(false);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getMadeForYouSectionList = async (url, token) => {
        setIsMadeForYouLoader(true);
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/MadeForYouList?customerid=${customerid}`, { headers })
        .then((response) => {
            setMadeForYouSectionList(response.data);
            setIsMadeForYouLoader(false);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getProductListApi = async (url, token, data) => {
        setIsTableLoader(true);
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(url+"/api/Product/GetProductList", data, { headers })
        .then((response) => {
            setProducts(response.data);
            setIsTableLoader(false);
        }).catch((error) => {
            console.log(error);
        });
    };
    const sendCartProduct = async (data) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
        
        await axios.post(baseUrl+`/api/Product/SaveCartTrackingDetails`, data, { headers })
        .then((response) => {
            if(!response.data.success) {
                console.log(response);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const getCustomerDeliveryAddresses = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Customer/GetCustomerDeliveryAddresses?customerid=${customerid}`, { headers })
        .then((response) => {
            setDeliveryAddressList(response.data);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getTransportationCompanyList = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Customer/GetTransportationCompanyList?customerid=${customerid}`, { headers })
        .then((response) => {
            setTransportationList(response.data);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getCartId = async (bodyRequest) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(baseUrl+`/api/Edi/GetCartID`, bodyRequest, { headers })
        .then((response) => {
            setCartId(response.data.id);
        }).catch((error) => {
            console.log(error);
        });
    };
    const getNewCartDetail = async (bodyRequest) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
    
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
    
        try {
            const response = await axios.post(baseUrl + `/api/Edi/GetNewCartDetail`, bodyRequest, { headers });
            return response.data; 
        } catch (error) {
            console.error("Error fetching cart details:", error);
            return null;
        }
    };
    const getProductExtraTaxes = async (cartProductId) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
    
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
    
        try {
            const response = await axios.get(baseUrl + `/api/Product/GetProductExtraTaxes?productid=${cartProductId}`, { headers });
            return response.data?.[0]; 
        } catch (error) {
            console.error("Error fetching cart details:", error);
            return null;
        }
    };
    const getCalculateShippingCost = async () => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
    
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        var currentdate = new Date(); 
        var datetime = currentdate.getHours() + ":" + currentdate.getMinutes() + ":" + currentdate.getSeconds();
        const items = [];
        if(calculateApiCart.length > 0) {
            calculateApiCart.map((item, index) => {
                const productPrice = parseFloat(item.UnitPrice);
                const productVat = (item.vat_percent / 100);
                const productQuantity = item.QTY1;
                const productTotalNetValue = productQuantity *  productPrice;
                const productTotalVat = productTotalNetValue * productVat;
                const productTotalAmount = productTotalNetValue + productTotalVat;
                const productTotalDiscount = item.discount_pct;

                items.push(
                    {
                        OrderDetailID: 0,
                        discount_amount: 0,
                        init_price: (productPrice).toFixed(2),
                        percent_discount: productTotalDiscount,
                        points: 0,
                        product_id: 0,
                        product_code: item.item_code,
                        quantity: (productQuantity).toFixed(2),
                        serial_no: 0,
                        sub_total: (productTotalNetValue).toFixed(2),
                        total: (productTotalAmount).toFixed(2),
                        vat_amount: productTotalVat,
                        free_qty: 0,
                        Netamount: (productTotalNetValue).toFixed(2),
                        discount_amount1: 0,
                        discount_amount2: 0,
                        discount_amount3: 0,
                        discount_amount4: 0,
                        discount_amount5: 0,
                        totalDiscount_amount: 0,
                        discount_pct1: 0,
                        discount_pct2: 0,
                        discount_pct3: 0,
                        discount_pct4: 0,
                        discount_pct5: 0,
                        listpriceamount: 0,
                        customerdicountpct: 0,
                        priceamount: (productPrice).toFixed(2),
                        stock_qty: 0,
                        unit_cost: 0,
                        StockDetailID: 0,
                        iscalculateditem: item.iscalculateditem,
                        referencedocumentid: item.referencedocumentid,
                        extra_taxes: item.extra_taxes
                    }
                )
            });

            var totalAmount = finalCartItems.totalAmount;
            var netAmount = finalCartItems.netAmount;
            var totalQuantity = finalCartItems.totalQuantity;
            var totalPoints = finalCartItems.totalPoints;
            var vats = finalCartItems.vats;
            var totalDiscountAmount = finalCartItems.discountAmount;
            var totalDiscountPercentage = finalCartItems.discountPercentage;
            var totalFinalAmount = finalCartItems.finalAmount
            var totalTaxes = finalCartItems.totalTaxes;
        } else {
            inputs.items.forEach((item, index) => {
                const prepareProductData = (product, quantity) => {
                    const productPrice = parseFloat(product.productprice);
                    const productVat = (product.vat_percentage / 100);
                    const productTotalNetValue = quantity * productPrice;
                    const productTotalVat = productTotalNetValue * productVat;
                    const productTotalAmount = productTotalNetValue + productTotalVat;

                    return {
                        OrderDetailID: 0,
                        discount_amount: product.discount_amount,
                        init_price: productPrice.toFixed(2),
                        percent_discount: product.discount,
                        points: 0,
                        product_id: product.productid,
                        product_code: product.item_code,
                        quantity: quantity.toFixed(2),
                        serial_no: 0,
                        sub_total: productTotalNetValue.toFixed(2),
                        total: productTotalAmount.toFixed(2),
                        vat_amount: productTotalVat.toFixed(2),
                        free_qty: 0,
                        Netamount: productTotalNetValue.toFixed(2),
                        discount_amount1: 0,
                        discount_amount2: 0,
                        discount_amount3: 0,
                        discount_amount4: 0,
                        discount_amount5: 0,
                        totalDiscount_amount: 0,
                        discount_pct1: 0,
                        discount_pct2: 0,
                        discount_pct3: 0,
                        discount_pct4: 0,
                        discount_pct5: 0,
                        listpriceamount: 0,
                        customerdicountpct: 0,
                        priceamount: productPrice.toFixed(2),
                        stock_qty: 0,
                        unit_cost: 0,
                        StockDetailID: 0,
                        iscalculateditem: false,
                        referencedocumentid: product.referencedocumentid,
                        extra_taxes: product.extra_taxes
                    };
                };
                items.push(prepareProductData(item.product, item.quantity));
                if (item.children && item.children.length > 0) {
                    item.children.forEach(child => {
                        items.push(prepareProductData(child.product, child.quantity));
                    });
                }
            });

            var totalAmount = virtualCartItems.totalAmount;
            var netAmount = virtualCartItems.netAmount;
            var totalQuantity = virtualCartItems.totalQuantity;
            var totalPoints = virtualCartItems.totalPoints;
            var vats = virtualCartItems.vats;
            var totalDiscountAmount = virtualCartItems.discountAmount;
            var totalDiscountPercentage = virtualCartItems.discountPercentage;
            var totalFinalAmount = virtualCartItems.finalAmount
            var totalTaxes = virtualCartItems.totalTaxes;
        }

        let bodyRequest = {
            OrderID: 0,
            BankID: "",
            ChequeExpiryDate: "",
            ChequeNo: "",
            CustomerID: parseInt(customerid),
            customerAddressID: 0,
            customerAddressCode: "",
            Mobile_App_Version12: "",
            Mobile_User_Mac_Address: "",
            PaymentDate: "",
            PaymentType: paymentMethod,
            PaymentTypeID: paymentTypeId,
            total_tax_amount: totalTaxes,
            comment: comment,
            delivery_date: moment(deliveryDate).format("DD-MM-YYYY"),
            discount_amount: totalDiscountAmount,
            final_amount: totalFinalAmount,
            orderCode: "",
            percent_discount: totalDiscountPercentage,
            sub_total: netAmount,
            tid: "",
            total_ChargeProduct: 0,
            total_gift_quantity: 0,
            total_pieces: totalQuantity,
            total_points: totalPoints,
            total_transportation: shippingCost,
            transactionDate: "",
            transactionId: "",
            vat_amount: vats,
            Discount_Redeem_Product_ID: 0,
            total_free_qty: 0,
            Order_status: "Draft",
            StockOrderID: 0,
            StartTime: datetime, 
            EndTime: datetime, 
            Latitude: "",
            Longitude: "",
            newTotalPointBalance: 0,
            OrderSeriesID: inputs.orderSeries,
            OrderSeriesNumber:  inputs.orderSeriesLastNumber+1,
            CourierTransactionID: 0,
            iscalculated: false,
            create_order: true,
            items: items,
            personid: personId,
            transportation_company_id: transportationCompanyId,
            cartnumber: uniqueKey
        };
    
        try {
            const response = await axios.post(baseUrl + `/api/Product/CalculateShippingCost`, bodyRequest, { headers });
            const shipCost = response.data?.[0].shippingcost || 0;
            setShippingCost(shipCost)
            localStorage.setItem("co_shipping", shipCost);
            return response.data; 
        } catch (error) {
            console.error("Error fetching cart details:", error);
            return null;
        }
        
    };
    // functions
    const openTab = (e, value) => {
        e.preventDefault();
        if(value === 'summary') {
            getCalculateShippingCost();
        }
        setShowTab(value);
        localStorage.setItem('co_tab', value);
    };
    const convertTo24HourFormat = (timeString) => { 
        const [time, period] = timeString.split(" ");
        const [hour, minute] = time.split(":");
        let formattedHour = parseInt(hour, 10);
    
        if (period === "PM" && formattedHour !== 12) {
            formattedHour += 12;
        } else if (period === "AM" && formattedHour === 12) {
            formattedHour = 0;
        }
    
        return `${formattedHour < 10 ? "0" : ""}${formattedHour}:${minute}:00`;
    };
    const handleSelectionChange = (data) => {
        setFilterSelectedData(data.oldSelected);
        setFilterInputsTwo({
            ...filterInputsTwo,
            'categoryIdArray' : data.categories,
            'categoryNameArray' :  data.categoriesOnly
        });
        setSubcatIds(data.subcategories);
        setIsCommonTableLoader(true);
        setIsTableLoader(true);
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCurrentPage(1);

        // Base requestData object with common properties
        let requestProductData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsPerPage,
            "searchtext": searchTerm,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": inputs.productTypeId,
            "product_code_search": filterInputsTwo.productCode,
            "product_desc_search": filterInputsTwo.description,
            "groupa": filterInputsTwo.productGroupIdArray,
            "categoryids": data.categories,
            "subcategoryids": data.subcategories
        };

        // Conditional updates based on sort field and type
        if (sortField === 'productname') {
            requestProductData.productname_asc = sortType === 'asc';
            requestProductData.productname_desc = sortType === 'desc';
        } else if (sortField === 'price') {
            requestProductData.price_asc = sortType === 'asc';
            requestProductData.price_desc = sortType === 'desc';
        } else if (sortField === 'unit') {
            requestProductData.mm_asc = sortType === 'asc';
            requestProductData.mm_desc = sortType === 'desc';
        } else if (sortField === 'point') {
            requestProductData.points_asc = sortType === 'asc';
            requestProductData.points_desc = sortType === 'desc';
        }

        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        getProductListApi(baseUrl, token, requestProductData);
    };
    const handleTabCheckDataFromChild = (data) => {
        if(inputs.items.length > 0 && data.tab === 'order') {
            Swal.fire({
                title: `${ t("are you sure")}?`,
                text: `${ t("if you click yes, you will lost all the data of the order, the cart will be empty")}`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `${ t('yes')}`,
                cancelButtonText: `${ t('no')}`
            }).then((result) => {
                if (result.isConfirmed) {
                    if(data.link === '/logout') {
                        authContext.logout();
                    } else {
                        navigate(data.link);
                    }
                    clearCartStorage();
                }
            });
        } else {
            if(data.link === '/logout') {
                authContext.logout();
                clearCartStorage();
            } else {
                navigate(data.link);
            }
        }
    };
    const clearCartStorage = () => {
        localStorage.removeItem('co_tab');
        localStorage.removeItem('co_coupon');
        localStorage.removeItem('co_comment');
        localStorage.removeItem('co_method');
        localStorage.removeItem('co_id');
        localStorage.removeItem('co_quantity');
        localStorage.removeItem('co_qty_message');
        localStorage.removeItem('co_items');
        localStorage.removeItem('co_calculate');
        localStorage.removeItem('co_code');
        localStorage.removeItem('co_calculate_json');
        localStorage.removeItem('co_calculate_button');
        localStorage.removeItem('co_calculate_filter');
        localStorage.removeItem("intercool_cartData");
        localStorage.removeItem("intercool_productCodes");
        localStorage.removeItem("intercool_staticQuantities");
        localStorage.removeItem('co_shipping');
        setCalculateJson([]);
        setCartProductCode([]);
        setProductStaticQuantity([]);
    };
    const clearData = () => {
        getUniqueKey(customerData.code);
        setFormButton(false);
        setShowFilterOne(false);
        setShowFilterTwo(false);
        setShowProductGroupOne(false);
        setShowProductGroupTwo(false);
        setReCalculate(false);
        setProductStaticQuantity([]);
        setProductStaticMessage([]);
        setComment("");
        setShowTab('common-items');
        setDeliveryDate(defaultDeliveryDate);
        setPersonName("");
        setPersonId(0);
        setTransportationCompanyId(0);
        setTransportationCompanyName("");
        setIsCompanyChecked(false);
        setIsAddressChecked(false);
        setShippingCost(0);

        // if(customerData.showcommon) {
        //     setShowTab('common-items')
        // } else {
        //     setShowTab('product-list')
        // }

        setInputs({
            ...inputs,
            orderSeries: "",
            orderSeriesLastNumber: "",
            orderSeriesDescription : "",
            productTypeDescription : "all",
            productTypeId: 0,
            couponCode: "",
            items: [],
            filteredItems: []
        });

        setFilterInputsOne({
            ...filterInputsOne,
            productCode: "",
            description: "",
            categoryIdArray: "",
            categoryNameArray: "",
            productGroupIdArray: "",
            productGroupNameArray: "",
        });

        setFilterInputsTwo({
            ...filterInputsTwo,
            productCode: "",
            description: "",
            categoryIdArray: "",
            categoryNameArray: "",
            productGroupIdArray: "",
            productGroupNameArray: "",
        });

        setCartItemsData({
            ...cartItemsData,
            "itemsCount" : 0,
            "totalQuantity" : 0,
            "totalPoints" : 0,
            "totalInitialPrice" : 0
        });

        setVirtualCartItems({
            ...virtualCartItems,
            "itemsCount" : 0,
            "totalQuantity" : 0,
            "netAmount" : 0,
            "vats" : 0,
            "totalAmount" : 0,
            "totalPoints" : 0,
            "discountPercentage" : 0,
            "discountAmount" : 0,
            "finalAmount" : 0,
            "totalTaxes": 0
        });

        setCalculateCartItems({
            ...calculateCartItems,
            "itemsCount" : 0,
            "totalQuantity" : 0,
            "netAmount" : 0,
            "vats" : 0,
            "totalAmount" : 0,
            "discountPercentage" : 0,
            "discountAmount" : 0,
            "finalAmount" : 0,
            "totalTaxes": 0
        });

        setFinalCartItems({
            ...finalCartItems,
            "itemsCount" : 0,
            "totalQuantity" : 0,
            "netAmount" : 0,
            "vats" : 0,
            "totalAmount" : 0,
            "discount" : 0,
            "transportationFee" : 0,
            "totalPoints" : 0,
            "discountPercentage" : 0,
            "discountAmount" : 0,
            "finalAmount" : 0,
            "totalTaxes": 0
        });
    };
    const handleClearData = (e) => {
        e.preventDefault();
        Swal.fire({
            title: `${ t("are you sure")}?`,
            text: `${ t("you want to clear")}!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) {
                logEvent('create_order_page', 'create_order', 'filter', 'clear-filter');
                clearData();
                clearCartStorage();
            }
        });
    };
    const handleDeliveryInfoFromChild = (data) => {
        getCustomerDeliveryAddresses(baseUrl, token);
        if(data === 'yes') {
            setShowDeliveryFormModal(false);
        }
    };
    const handleTransportationInfoFromChild = (data) => {
        getTransportationCompanyList(baseUrl, token);
        if(data === 'yes') {
            setShowTransportationFormModal(false);
        }
    };
    const getUniqueKey = (code) => {
        const date = new Date();
        const uniqueId = `C${(date.getTime() % 10000).toString().padStart(4, '0')}`;
        setUniqueKey(uniqueId);

        const bodyRequest = {
            "customerid": customerid,
            "customercode": code,
            "orderdate": moment().format("DD-MM-YYYY"),
            "tempcartnumber": uniqueId
        };
        getCartId(bodyRequest);
    };
    const openPaymentMethod = (e) => {
        e.preventDefault();
        setShowPaymentMethod(!showPaymentMethod);
    };
    const handlePaymentMethod = (e, value) => {
        e.preventDefault();
        setShowPaymentMethod(!showPaymentMethod);
        setPaymentMethod(value.name);
        setPaymentTypeId(value.id);
        localStorage.setItem('co_method', value.name);
        localStorage.setItem('co_id', value.id);
    };
    const handleTransportationCompany = (data) => {
        setTransportationCompanyId(data.id);
        setTransportationCompanyName(data.text);
    };
    const handleDeliveryAddress = (data) => {
        setPersonId(data.id);
        setPersonName(data.line1);
    };
    const handleDateDataFromChild = (data) => {
        setDeliveryDate(data);
    };
    const handleCommentChange = (e) => {
        setComment(e.target.value);
        logEvent('create_order_page', 'cart', 'comment', e.target.value);
    };
    // common
    const handleShowSort = (e, list) => {
        if(list === 'one') {
            setShowSortOne(!showSortOne); 
            setShowFilterOne(false);
        } else if (list === 'two') {
            setShowSortTwo(!showSortTwo); 
            setShowFilterTwo(false);
        }
    };
    const handleShowFilter = (e, list) => {
        if(list === 'one') {
            setShowFilterOne(!showFilterOne);
            setShowSortOne(false);  
        } else if (list === 'two') {
            setShowFilterTwo(!showFilterTwo); 
            setShowSortTwo(false); 
        }
    };
    const handleShowCategory = (e, list) => {
        if(list === 'one') {
            setShowCategoryOne(!showCategoryOne)
            setShowProductGroupOne(false);  
        } else if (list === 'two') {
            setShowCategoryTwo(!showCategoryTwo)
            setShowProductGroupTwo(false); 
        }
    };
    const handleShowProductGroup = (e, list) => {
        if(list === 'one') {
            setShowProductGroupOne(!showProductGroupOne)
            setShowCategoryOne(false);  
        } else if (list === 'two') {
            setShowProductGroupTwo(!showProductGroupTwo)
            setShowCategoryTwo(false); 
        }
    };
    const handleChange = (e, list) => {
        e.preventDefault();

        if(list === 'one') {
            setFilterInputsOne({
                ...filterInputsOne,
                [e.target.name]: e.target.value,
            });
        } else if(list === 'two') {
            setFilterInputsTwo({
                ...filterInputsTwo,
                [e.target.name]: e.target.value,
            });
        }
    };
    const handleFilterSubmit = (e, list) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        if(list === 'one') {
            setIsCommonTableLoader(true);
            setCommonItems({
                "total_record": 0,
                "totalpages": 0,
                "list": []
            });
            setCommonItemsCurrentPage(1);

            // Build the common requestData object with all sort flags defaulting to false
            const requestData = {
                category: 0,
                subcategory: 0,
                customerid: customerid,
                pagenumber: 1,
                recordLimit: rowsCommonItemsPerPage,
                searchtext: searchCommonItemsTerm,
                productcode_asc: false,
                productcode_desc: false,
                productdescription_asc: false,
                productdescription_desc: false,
                productstock_desc: false,
                productstock_asc: false,
                default_asc: false,
                default_desc: false,
                productname_asc: false,
                productname_desc: false,
                price_asc: false,
                price_desc: false,
                mm_asc: false,
                mm_desc: false,
                vat_asc: false,
                vat_desc: false,
                points_asc: false,
                points_desc: false,
                producttypeid: 0,
                product_code_search: filterInputsOne.productCode,
                product_desc_search: filterInputsOne.description,
                groupa: filterInputsOne.productGroupIdArray,
                categoryids: filterInputsOne.categoryIdArray
            };
            
            // Map the field names to the corresponding sort key prefixes.
            // Note: 'unit' maps to 'mm', 'point' maps to 'points', and 'code' maps to 'productcode'
            const sortMapping = {
                productname: 'productname',
                price: 'price',
                unit: 'mm',
                point: 'points',
                code: 'productcode'
            };
            
            // If the provided sort field exists in our mapping, set its corresponding flag to true.
            if (sortMapping[sortCommonItemsField]) {
                const sortKey = `${sortMapping[sortCommonItemsField]}_${sortCommonItemsType}`; // e.g., "price_asc"
                requestData[sortKey] = true;
            }
            
            getCommonItems(baseUrl, token, requestData);
            setShowFilterOne(!showFilterOne);
            setShowProductGroupOne(false);
            setShowCategoryOne(false);
            logEvent('create_order_page', 'filter', 'common-items', requestData);
        } else if(list === 'two') {
            setIsTableLoader(true);
            setProducts({
                "total_record": 0,
                "totalpages": 0,
                "list": []
            });
            setCurrentPage(1);

            // Build a base requestData object with common properties and all sort flags set to false
            const requestData = {
                category: 0,
                subcategory: 0,
                customerid: customerid,
                pagenumber: 1,
                recordLimit: rowsPerPage,
                searchtext: searchTerm,
                productcode_asc: false,
                productcode_desc: false,
                productdescription_asc: false,
                productdescription_desc: false,
                productstock_desc: false,
                productstock_asc: false,
                default_asc: false,
                default_desc: false,
                productname_asc: false,
                productname_desc: false,
                price_asc: false,
                price_desc: false,
                mm_asc: false,
                mm_desc: false,
                vat_asc: false,
                vat_desc: false,
                points_asc: false,
                points_desc: false,
                producttypeid: inputs.productTypeId,
                product_code_search: filterInputsTwo.productCode,
                product_desc_search: filterInputsTwo.description,
                groupa: filterInputsTwo.productGroupIdArray,
                categoryids: filterInputsTwo.categoryIdArray,
                subcategoryids: subcatIds
            };
            
            // Create a mapping from sort field names to their sort key prefixes.
            // Note: "unit" maps to "mm" and "point" maps to "points".
            // If needed, you can also map "code" to "productcode".
            const sortMapping = {
                productname: 'productname',
                price: 'price',
                unit: 'mm',
                point: 'points',
                code: 'productcode'
            };
            
            // If sortField exists in our mapping, dynamically set the correct sort flag
            if (sortMapping[sortField]) {
                const sortKey = `${sortMapping[sortField]}_${sortType}`; // e.g., "price_asc" or "productname_desc"
                requestData[sortKey] = true;
            }
            
            getProductListApi(baseUrl, token, requestData);
            setShowFilterTwo(!showFilterTwo);
            setShowProductGroupTwo(false);
            setShowCategoryTwo(false);
            logEvent('create_order_page', 'filter', 'product-list', requestData);
        }
    };
    const clearFilterData = (e, list) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        if(list === 'one') {
            setIsCommonTableLoader(true);
            setCommonItems({
                "total_record": 0,
                "totalpages": 0,
                "list": []
            });
            setFilterInputsOne({
                ...filterInputsOne,
                'productCode': "",
                'description': "",
                'categoryIdArray': "",
                'categoryNameArray': "",
                'productGroupIdArray': "",
                'productGroupNameArray': "",
                'groupName': "",
                'groupId': 0,
            });
            setShowFilterOne(!showFilterOne);
            setShowProductGroupOne(false);
            setShowCategoryOne(false);
            setShowTab('common-items');
            const requestData = {
                "category": 0,
                "subcategory": 0,
                "customerid": customerid,
                "pagenumber": 1,
                "recordLimit": rowsCommonItemsPerPage,
                "searchtext": searchCommonItemsTerm,
                "productcode_asc": false,
                "productcode_desc": false,
                "productdescription_asc": false,
                "productdescription_desc": false,
                "productstock_desc": false,
                "productstock_asc": false,
                "default_asc": false,
                "default_desc": false,
                "productname_asc": false,
                "productname_desc": false,
                "price_asc": false,
                "price_desc": false,
                "mm_asc": false,
                "mm_desc": false,
                "vat_asc": false,
                "vat_desc": false,
                "points_asc": false,
                "points_desc": false,
                "producttypeid": 0,
                "product_code_search": "",
                "product_desc_search": "",
                "groupa": "",
                "categoryids": ""
            }; 
            getCommonItems(baseUrl, token, requestData);
            logEvent('create_order_page', 'filter', 'common-items', 'clear-filter');
        } else if(list === 'two') {
            setIsTableLoader(true);
            setProducts({
                "total_record": 0,
                "totalpages": 0,
                "list": []
            });
            setFilterInputsTwo({
                ...filterInputsTwo,
                'productCode': "",
                'description': "",
                'categoryIdArray': "",
                'categoryNameArray': "",
                'productGroupIdArray': "",
                'productGroupNameArray': "",
            });
            setShowFilterTwo(!showFilterTwo);
            setShowProductGroupTwo(false);
            setShowCategoryTwo(false);
            setShowTab('product-list');
    
            const requestData = {
                "category": 0,
                "subcategory": 0,
                "customerid": customerid,
                "pagenumber": 1,
                "recordLimit": rowsPerPage,
                "searchtext": searchTerm,
                "productcode_asc": false,
                "productcode_desc": false,
                "productdescription_asc": false,
                "productdescription_desc": false,
                "productstock_desc": false,
                "productstock_asc": false,
                "default_asc": false,
                "default_desc": false,
                "productname_asc": false,
                "productname_desc": false,
                "price_asc": false,
                "price_desc": false,
                "mm_asc": false,
                "mm_desc": false,
                "vat_asc": false,
                "vat_desc": false,
                "points_asc": false,
                "points_desc": false,
                "producttypeid": inputs.productTypeId,
                "product_code_search": "",
                "product_desc_search": "",
                "groupa": "",
                "categoryids": "",
                "subcategoryids": subcatIds
            }; 
            getProductListApi(baseUrl, token, requestData);
            logEvent('create_order_page', 'filter', 'product-list', 'clear-filter');
        }
    };
    const handleCommonSearchDataFromChild = (data) => {
        setIsCommonTableLoader(true);
        setIsTableLoader(true);

        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });

        setSearchCommonItemsTerm(data);
        setCommonItemsCurrentPage(1);
        setSearchTerm(data);
        setCurrentPage(1);

        // Base requestData object with common properties
        let requestCommonData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsCommonItemsPerPage,
            "searchtext": data,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": 0,
            "product_code_search": filterInputsOne.productCode,
            "product_desc_search": filterInputsOne.description,
            "groupa": filterInputsOne.productGroupIdArray,
            "categoryids": filterInputsOne.categoryIdArray
        };
        // Base requestData object with common properties
        let requestProductData = {
            "category": 0,
            "subcategory": 0,
            "customerid": customerid,
            "pagenumber": 1,
            "recordLimit": rowsPerPage,
            "searchtext": data,
            "productcode_asc": false,
            "productcode_desc": false,
            "productdescription_asc": false,
            "productdescription_desc": false,
            "productstock_desc": false,
            "productstock_asc": false,
            "default_asc": false,
            "default_desc": false,
            "productname_asc": false,
            "productname_desc": false,
            "price_asc": false,
            "price_desc": false,
            "mm_asc": false,
            "mm_desc": false,
            "vat_asc": false,
            "vat_desc": false,
            "points_asc": false,
            "points_desc": false,
            "producttypeid": inputs.productTypeId,
            "product_code_search": filterInputsTwo.productCode,
            "product_desc_search": filterInputsTwo.description,
            "groupa": filterInputsTwo.productGroupIdArray,
            "categoryids": filterInputsTwo.categoryIdArray,
            "subcategoryids": subcatIds
        };

        // Conditional updates based on sort field and type
        if (sortCommonItemsField === 'productname') {
            requestCommonData.productname_asc = sortCommonItemsType === 'asc';
            requestCommonData.productname_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'price') {
            requestCommonData.price_asc = sortCommonItemsType === 'asc';
            requestCommonData.price_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'unit') {
            requestCommonData.mm_asc = sortCommonItemsType === 'asc';
            requestCommonData.mm_desc = sortCommonItemsType === 'desc';
        } else if (sortCommonItemsField === 'point') {
            requestCommonData.points_asc = sortCommonItemsType === 'asc';
            requestCommonData.points_desc = sortCommonItemsType === 'desc';
        }

        // Conditional updates based on sort field and type
        if (sortField === 'productname') {
            requestProductData.productname_asc = sortType === 'asc';
            requestProductData.productname_desc = sortType === 'desc';
        } else if (sortField === 'price') {
            requestProductData.price_asc = sortType === 'asc';
            requestProductData.price_desc = sortType === 'desc';
        } else if (sortField === 'unit') {
            requestProductData.mm_asc = sortType === 'asc';
            requestProductData.mm_desc = sortType === 'desc';
        } else if (sortField === 'point') {
            requestProductData.points_asc = sortType === 'asc';
            requestProductData.points_desc = sortType === 'desc';
        }

        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        getCommonItems(baseUrl, token, requestCommonData);
        getProductListApi(baseUrl, token, requestProductData);
        logEvent('create_order_page', 'common-items', 'search', data);
        logEvent('create_order_page', 'product-list', 'search', data);
    };
    // category
    const handleSortTypeOneDataFromChild = (e, data) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        setShowSortOne(!showSortOne); 
        setCommonItemsSortField(data.field);
        setCommonItemsSortType(data.type);
        setCommonItemsCurrentPage(1);
        setCommonItemsSortName(data.name);

        // Create a base request data object that is common across all cases
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsCommonItemsPerPage,
            searchtext: searchCommonItemsTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputsOne.productCode,
            product_desc_search: filterInputsOne.description,
            groupa: filterInputsOne.productGroupIdArray,
            categoryids: filterInputsOne.categoryIdArray
        };
        
        // Map the incoming field to the appropriate sort key prefix.
        // Notice: "unit" maps to "mm" and "code" maps to "productcode".
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            code: 'productcode'
        };
        
        // If the field exists in our mapping, set the correct sort key to true.
        if (sortMapping[data.field]) {
            const sortKey = `${sortMapping[data.field]}_${data.type}`;
            requestData[sortKey] = true;
        }
        
        // Call the API with the dynamically generated requestData.
        getCommonItems(baseUrl, token, requestData);
        logEvent('create_order_page', 'sort', 'common-items', data);
    };
    const handleCategoryOneDataFromChild = (data) => {
        setFilterInputsOne({
            ...filterInputsOne,
            'categoryIdArray' : data.id.toString(),
            'categoryNameArray' : data.name.toString()
        });
    };
    const handleProductGroupOneDataFromChild = (data) => {
        setFilterInputsOne({
            ...filterInputsOne,
            'productGroupIdArray' : data.id.toString(),
            'productGroupNameArray' : data.name.toString()
        });
    };
    const handleCommonItemsSortDataFromChild = (data) => {
        setCommonItemsSortField(data.field);
        setCommonItemsSortType(data.type);
        setCommonItemsCurrentPage(1);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Build the base requestData with all common fields and default sort flags (all false)
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsCommonItemsPerPage,
            searchtext: searchCommonItemsTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputsOne.productCode,
            product_desc_search: filterInputsOne.description,
            groupa: filterInputsOne.productGroupIdArray,
            categoryids: filterInputsOne.categoryIdArray
        };
        
        // Map incoming field names to their corresponding sort key prefixes.
        // Note: "unit" maps to "mm" and "point" maps to "points", and "productname", "price" use the same key.
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points',
            code: 'productcode' // if needed in the future
        };
        
        // If the provided data.field exists in the mapping, build the sort key (like "price_asc")
        if (sortMapping[data.field]) {
            const sortKey = `${sortMapping[data.field]}_${data.type}`; // e.g., "productname_asc"
            requestData[sortKey] = true;
        }
        
        getCommonItems(baseUrl, token, requestData);
        logEvent('create_order_page', 'common-items', 'sort', data);
    };
    const handleCommonItemsCurrentPage = (page) => {
        setIsCommonTableLoader(true);
        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCommonItemsCurrentPage(page);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Build the base requestData with all common fields and default sort flags (all false)
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: page,
            recordLimit: rowsCommonItemsPerPage,
            searchtext: searchCommonItemsTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputsOne.productCode,
            product_desc_search: filterInputsOne.description,
            groupa: filterInputsOne.productGroupIdArray,
            categoryids: filterInputsOne.categoryIdArray
        };
        
        // Create a mapping for the sort fields to the corresponding key prefixes.
        // For example: "unit" maps to "mm" and "point" maps to "points".
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the provided sortCommonItemsField exists in our mapping,
        // build the sort flag key (e.g. "price_asc" or "productname_desc") and set it to true.
        if (sortMapping[sortCommonItemsField]) {
            const sortKey = `${sortMapping[sortCommonItemsField]}_${sortCommonItemsType}`;
            requestData[sortKey] = true;
        }
        
        getCommonItems(baseUrl, token, requestData);
        logEvent('create_order_page', 'common-items', 'pagination', page);
    };
    const handleCommonItemsPerPage = (row) => {
        setIsCommonTableLoader(true);
        setCommonItems({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCommonItemsRowsPerPage(row);
        setCommonItemsCurrentPage(1);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        
        // Build the base requestData with all common fields and sort flags defaulting to false
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: row,
            searchtext: searchCommonItemsTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: 0,
            product_code_search: filterInputsOne.productCode,
            product_desc_search: filterInputsOne.description,
            groupa: filterInputsOne.productGroupIdArray,
            categoryids: filterInputsOne.categoryIdArray
        };
        
        // Map sort fields to their corresponding sort key prefixes
        // "unit" becomes "mm" and "point" becomes "points"
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the provided sort field exists in our mapping, build the sort flag and set it to true
        if (sortMapping[sortCommonItemsField]) {
            const sortKey = `${sortMapping[sortCommonItemsField]}_${sortCommonItemsType}`; // e.g., "productname_asc"
            requestData[sortKey] = true;
        }
        
        getCommonItems(baseUrl, token, requestData);
        logEvent('create_order_page', 'common-items', 'pagination-per-page', row);
    };
    // product
    const handleSortTypeTwoDataFromChild = (e, data) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        setSortField(data.field);
        setSortType(data.type);
        setCurrentPage(1);
        setShowSortTwo(!showSortTwo); 
        setSortName(data.name);

        // Build the base request data object (all sort flags default to false)
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: inputs.productTypeId,
            product_code_search: filterInputsTwo.productCode,
            product_desc_search: filterInputsTwo.description,
            groupa: filterInputsTwo.productGroupIdArray,
            categoryids: filterInputsTwo.categoryIdArray,
            subcategoryids: subcatIds
        };
        
        // Mapping for data.field values to their corresponding sort key prefix
        // Note: "unit" maps to "mm" and "code" maps to "productcode"
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            code: 'productcode'
        };
        
        // If the field provided is in our mapping, set the correct sort property to true
        if (sortMapping[data.field]) {
            const sortKey = `${sortMapping[data.field]}_${data.type}`; // e.g., "price_asc"
            requestData[sortKey] = true;
        }
        
        // Call the API with the dynamically built requestData
        getProductListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'sort', 'product-list', data);
    };
    const handleCategoryTwoDataFromChild = (data) => {
        setFilterInputsTwo({
            ...filterInputsTwo,
            'categoryIdArray' : data.id.toString(),
            'categoryNameArray' : data.name.toString()
        });
    };
    const handleProductGroupTwoDataFromChild = (data) => {
        setFilterInputsTwo({
            ...filterInputsTwo,
            'productGroupIdArray' : data.id.toString(),
            'productGroupNameArray' : data.name.toString()
        });
    };
    const handleSortDataFromChild = (data) => {
        setSortField(data.field);
        setSortType(data.type);
        setCurrentPage(1);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Create a base requestData object with all common properties and default sort flags set to false
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: rowsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: inputs.productTypeId,
            product_code_search: filterInputsTwo.productCode,
            product_desc_search: filterInputsTwo.description,
            groupa: filterInputsTwo.productGroupIdArray,
            categoryids: filterInputsTwo.categoryIdArray,
            subcategoryids: subcatIds
        };
        
        // Map the incoming field to the corresponding sort key prefix.
        // If you ever need to support "unit" or "point", they can be mapped accordingly.
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the field exists in our mapping, build the sort key (e.g. "productname_asc") and set it to true
        if (sortMapping[data.field]) {
            const sortKey = `${sortMapping[data.field]}_${data.type}`;
            requestData[sortKey] = true;
        }
        
        getProductListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'product-list', 'sort', data);
    };
    const handleCurrentPage = (page) => {
        setIsTableLoader(true);
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCurrentPage(page);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Build the base requestData object with common fields and default sort flags set to false.
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: page,
            recordLimit: rowsPerPage,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: inputs.productTypeId,
            product_code_search: filterInputsTwo.productCode,
            product_desc_search: filterInputsTwo.description,
            groupa: filterInputsTwo.productGroupIdArray,
            categoryids: filterInputsTwo.categoryIdArray,
            subcategoryids: subcatIds
        };
        
        // Map sort fields to the corresponding sort key prefix.
        // "unit" maps to "mm" and "point" maps to "points" if needed.
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the sort field exists in our mapping, build the sort key (e.g. "productname_asc") and set it to true.
        if (sortMapping[sortField]) {
            const sortKey = `${sortMapping[sortField]}_${sortType}`;
            requestData[sortKey] = true;
        }
    
        getProductListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'product-list', 'pagination', page);
    };
    const handlePerPage = (row) => {
        setIsTableLoader(true);
        setProducts({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setRowsPerPage(row);
        setCurrentPage(1);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        // Create a base request object with common properties and all sort flags set to false.
        const requestData = {
            category: 0,
            subcategory: 0,
            customerid: customerid,
            pagenumber: 1,
            recordLimit: row,
            searchtext: searchTerm,
            productcode_asc: false,
            productcode_desc: false,
            productdescription_asc: false,
            productdescription_desc: false,
            productstock_desc: false,
            productstock_asc: false,
            default_asc: false,
            default_desc: false,
            productname_asc: false,
            productname_desc: false,
            price_asc: false,
            price_desc: false,
            mm_asc: false,
            mm_desc: false,
            vat_asc: false,
            vat_desc: false,
            points_asc: false,
            points_desc: false,
            producttypeid: inputs.productTypeId,
            product_code_search: filterInputsTwo.productCode,
            product_desc_search: filterInputsTwo.description,
            groupa: filterInputsTwo.productGroupIdArray,
            categoryids: filterInputsTwo.categoryIdArray,
            subcategoryids: subcatIds
        };
        
        // Create a mapping from sort field names to their corresponding property key prefixes.
        // (If your API ever supports additional fields like "unit" or "point", add them here.)
        const sortMapping = {
            productname: 'productname',
            price: 'price',
            unit: 'mm',
            point: 'points'
        };
        
        // If the sort field exists in our mapping, build the sort key dynamically.
        // For example, if sortField is "productname" and sortType is "asc", the key becomes "productname_asc".
        if (sortMapping[sortField]) {
            const sortKey = `${sortMapping[sortField]}_${sortType}`;
            requestData[sortKey] = true;
        }
        
        getProductListApi(baseUrl, token, requestData);
        logEvent('create_order_page', 'product-list', 'pagination_per_page', row);
    };
    // related to cart
    const handleApplyCouponCode = async (e) => {
        e.preventDefault();
        if(inputs.couponCode.trim().length > 0) {
            Swal.fire({
                position: "center",
                icon: "success",
                title: `${ t("coupon code applied")}!`,
                showConfirmButton: false,
                timer: 1500
            });
        }
    };
    const handleCouponCodeChange = (e) => {
        e.preventDefault();

        setInputs({
            ...inputs,
            [e.target.name]: e.target.value,
        });
        localStorage.setItem('co_coupon',  e.target.value);
        logEvent('create_order_page', 'cart', 'coupon', e.target.value);
    };
    // bundle logic
    const handleBundleQuantity = async (data) => {
        try {
            setMainProduct(data);
            setIsBundleLoading(data.id);
    
            const headers = {
                "Accept": "Application/json",
                "Content-Type": "Application/json",
                "Authorization": `Bearer ${token}`
            };
    
            const response = await axios.get(`${baseUrl}/api/Product/GetBundleProductList?productid=${data.id}`, { headers });
    
            if (response.data.list?.length) {
                await handleDirectProductAddition(data, 'no');
            } else {
                await handleDirectProductAddition(data, 'yes');
                return;
            }
    
            setShowBundleModal(true);
    
            const existingParent = inputs.items?.find(item => item.id === data.id && item.type === "parent");
            const existingChildren = existingParent ? existingParent.children : [];
    
            const bundleLists = response.data.list.map((product) => {
                const isPreselected = existingChildren.some(child => child.id === product.productid);
    
                return {
                    id: product.productid,
                    product,
                    quantity: parseFloat(data.quantity),
                    action: 'add',
                    type: 'child',
                    preselected: isPreselected
                };
            });
    
            setBundleProducts(bundleLists);
            setSelectedItems(bundleLists.filter(item => item.preselected));
        } catch (error) {
            console.error("Error fetching bundle details:", error);
        } finally {
            setIsBundleLoading(0);
        }
    };
    const handleSelectedBundle = (e, item) => {
        setSelectedItems((prevItems) => {
            const isItemSelected = prevItems.some(selected => selected.id === item.product.productid);
    
            if (isItemSelected) {
                return prevItems.filter(selected => selected.id !== item.product.productid);
            } else {
                return [{ ...item, id: item.product.productid, parentId: mainProduct.id }];
            }
        });
    };
    const handleDirectProductAddition = async (productData, type) => {
        if (!productData || !productData.product) {
            console.error("Invalid product data", productData);
            return;
        }
    
        const bodyRequest = {
            "tempcartid": cartId,
            "productid": productData.id,
            "productcode": productData.product.item_code,
            "qty": productData.quantity,
            "price": productData.product.productprice
        };

        const taxResponse = await getProductExtraTaxes(productData.id);
        const extraTaxes = taxResponse?.nettaxvalue || 0;
        const cartResponse = await getNewCartDetail(bodyRequest);
        const discountPercent = cartResponse?.discountPercent || 0;
        const discountAmount = cartResponse?.discountAmount || 0;
        const referenceDocumentId = cartResponse?.id || "";

        setInputs((prevInputs) => {
            let updatedItems = [...(prevInputs.items || [])];
            let existingProductIndex = updatedItems.findIndex(item => item.id === productData.id && item.type === "parent");
    
            if (existingProductIndex !== -1) {
                updatedItems[existingProductIndex].quantity = productData.quantity;
                updatedItems[existingProductIndex].product.extra_taxes = extraTaxes;
                updatedItems[existingProductIndex].product.discount = discountPercent;
                updatedItems[existingProductIndex].product.discount_amount = discountAmount;
                updatedItems[existingProductIndex].product.referencedocumentid = referenceDocumentId;

                if (updatedItems[existingProductIndex].children) {
                    const childUpdates = updatedItems[existingProductIndex].children.map(async (child) => {
                        const childBodyRequest = {
                            "tempcartid": cartId,
                            "productid": child.id,
                            "productcode": child.product.item_code,
                            "qty": productData.quantity,
                            "price": child.product.productprice
                        };
    
                        const taxChildResponse = await getProductExtraTaxes(child.id);
                        const childExtraTaxes = taxChildResponse?.nettaxvalue || 0;
                        const childResponse = await getNewCartDetail(childBodyRequest);
                        const childDiscountPercent = childResponse?.discountPercent || 0;
                        const childDiscountAmount = childResponse?.discountAmount || 0;
                        const childReferenceDocumentId = childResponse?.id || "";

                        return {
                            ...child,
                            quantity: productData.quantity,
                            product: {
                                ...child.product,
                                discount: childDiscountPercent,
                                discount_amount: childDiscountAmount,
                                referencedocumentid: childReferenceDocumentId,
                                extra_taxes: childExtraTaxes
                            }
                        };
                    });
    
                    Promise.all(childUpdates).then((updatedChildren) => {
                        updatedItems[existingProductIndex].children = updatedChildren;
                        calculateBundleSummary(updatedItems);
                    });
                } else {
                    calculateBundleSummary(updatedItems);
                }
            } else {
                updatedItems.push({
                    ...productData,
                    type: "parent",
                    product: {
                        ...productData.product,
                        discount: discountPercent,
                        discount_amount: discountAmount,
                        referencedocumentid: referenceDocumentId,
                        extra_taxes: extraTaxes
                    },
                    children: productData.children?.map(child => ({
                        ...child,
                        product: {
                            ...child.product
                        }
                    })) || []
                });

                if (productData.children && productData.children.length > 0) {
                    const childUpdates = productData.children.map(async (child) => {
                        const childBodyRequest = {
                            "tempcartid": cartId,
                            "productid": child.id,
                            "productcode": child.product.item_code,
                            "qty": productData.quantity,
                            "price": child.product.productprice
                        };
    
                        const taxChildResponse = await getProductExtraTaxes(child.id);
                        const childExtraTaxes = taxChildResponse?.nettaxvalue || 0;
                        const childResponse = await getNewCartDetail(childBodyRequest);
                        const childDiscountPercent = childResponse?.discountPercent || 0;
                        const childDiscountAmount = childResponse?.discountAmount || 0;
                        const childReferenceDocumentId = childResponse?.id || "";

                        return {
                            ...child,
                            product: {
                                ...child.product,
                                discount: childDiscountPercent,
                                discount_amount: childDiscountAmount,
                                referencedocumentid: childReferenceDocumentId,
                                extra_taxes: childExtraTaxes
                            }
                        };
                    });
    
                    Promise.all(childUpdates).then((updatedChildren) => {
                        updatedItems[updatedItems.length - 1].children = updatedChildren;
                        calculateBundleSummary(updatedItems);
                    });
                } else {
                    calculateBundleSummary(updatedItems);
                }
            }
    
            return {
                ...prevInputs,
                items: updatedItems,
                filteredItems: updatedItems,
            };
        });
    
        if (type === 'yes') {
            Swal.fire({
                position: "center",
                icon: "success",
                title: `${t("product added")}!`,
                showConfirmButton: false,
                timer: 1500
            });
        }
    };
    const handleProductAddToCart = async (childDataList) => {
        if (!mainProduct || !mainProduct.product) {
            console.error("No parent product available or mainProduct.product is missing", mainProduct);
            return;
        }
    
        setInputs((prevInputs) => {
            let updatedItems = [...(prevInputs.items || [])];
            let existingParentIndex = updatedItems.findIndex(item => item.id === mainProduct.id && item.type === "parent");
    
            if (existingParentIndex !== -1) {
                updatedItems[existingParentIndex].quantity = mainProduct.quantity;
    
                const childUpdates = childDataList.map(async (child) => {
                    const childBodyRequest = {
                        "tempcartid": cartId,
                        "productid": child.id,
                        "productcode": child.product.item_code,
                        "qty": mainProduct.quantity,
                        "price": child.product.productprice
                    };
    
                    const taxChildResponse = await getProductExtraTaxes(child.id);
                    const childExtraTaxes = taxChildResponse?.nettaxvalue || 0;
                    const childResponse = await getNewCartDetail(childBodyRequest);
                    const childDiscountPercent = childResponse?.discountPercent || 0;
                    const childDiscountAmount = childResponse?.discountAmount || 0;
                    const childReferenceDocumentId = childResponse?.id || "";

                    return {
                        ...child,
                        type: "child",
                        quantity: mainProduct.quantity,
                        product: {
                            ...child.product,
                            discount: childDiscountPercent,
                            discount_amount: childDiscountAmount,
                            referencedocumentid: childReferenceDocumentId,
                            extra_taxes: childExtraTaxes
                        }
                    };
                });
    
                Promise.all(childUpdates).then((updatedChildren) => {
                    updatedItems[existingParentIndex].children = updatedChildren;
                    calculateBundleSummary(updatedItems);
                });

                calculateBundleSummary(updatedItems);
            } else {
                updatedItems.push({
                    ...mainProduct,
                    type: "parent",
                    product: {
                        ...mainProduct.product,
                    },
                    children: childDataList.map(child => ({
                        ...child,
                        type: "child",
                        quantity: mainProduct.quantity
                    }))
                });
    
                const childUpdates = childDataList.map(async (child) => {
                    const childBodyRequest = {
                        "tempcartid": cartId,
                        "productid": child.id,
                        "productcode": child.product.item_code,
                        "qty": mainProduct.quantity,
                        "price": child.product.productprice
                    };
    
                    const taxChildResponse = await getProductExtraTaxes(child.id);
                    const childExtraTaxes = taxChildResponse?.nettaxvalue || 0;
                    const childResponse = await getNewCartDetail(childBodyRequest);
                    const childDiscountPercent = childResponse?.discountPercent || 0;
                    const childDiscountAmount = childResponse?.discountAmount || 0;
                    const childReferenceDocumentId = childResponse?.id || "";

                    return {
                        ...child,
                        product: {
                            ...child.product,
                            discount: childDiscountPercent,
                            discount_amount: childDiscountAmount,
                            referencedocumentid: childReferenceDocumentId,
                            extra_taxes: childExtraTaxes
                        }
                    };
                });
    
                Promise.all(childUpdates).then((updatedChildren) => {
                    updatedItems[updatedItems.length - 1].children = updatedChildren;
                    calculateBundleSummary(updatedItems);
                });

                calculateBundleSummary(updatedItems);
            }
    
            return {
                ...prevInputs,
                items: updatedItems,
                filteredItems: updatedItems,
            };
        });
    
        Swal.fire({
            position: "center",
            icon: "success",
            title: `${t("product added")}!`,
            showConfirmButton: false,
            timer: 1500
        });
    
        setShowBundleModal(false);
    };
    const handleUpdateBundleItems = (e) => {
        e.preventDefault();
        handleProductAddToCart(selectedItems);
    };
    const calculateBundleSummary = (itemsArray) => {
        let newTotalQuantity = 0;
        let newTotalVat = 0;
        let newTotalNetValue = 0;
        let newTotalPoints = 0;
        let totalItemsCount = 0;
        let newTotalDiscountPercentage = 0;
        let newTotalDiscountAmount = 0;
        let newTotalTaxes = 0;
        let newTotalPrice = 0;
    
        itemsArray.forEach((obj) => {
            if (!obj.product) return;
    
            const quantity = obj.quantity || 0;
            const price = obj.product?.productprice || 0;
            const vatRate = (obj.product?.vat_percentage || 0) / 100;
            const discountPercentage = obj.product?.discount || 0;
            const discountAmount = Number(obj.product?.discount_amount) || 0;
            const taxes = obj.product?.extra_taxes || 0;
            const point = obj.product?.loyalty_point || 0;
            const amount = price * quantity;
            const vatAmount = vatRate * amount;
    
            newTotalPrice += price;
            newTotalQuantity += quantity;
            newTotalNetValue += amount;
            newTotalVat += vatAmount;
            newTotalDiscountPercentage += discountPercentage;
            newTotalDiscountAmount += discountAmount;
            newTotalTaxes += (taxes * quantity);
            newTotalPoints += (point * quantity);
            totalItemsCount++;
    
            if (obj.children && obj.children.length > 0) {
                obj.children.forEach((child) => {
                    if (!child.product) return;
    
                    const childQuantity = child.quantity || 0;
                    const childPrice = child.product?.productprice || 0;
                    const childVatRate = (child.product?.vat_percentage || 0) / 100;
                    const childPoint = child.product?.loyalty_point || 0;
                    const childDiscountPecentage = child.product?.discount || 0;
                    const childDiscountAmount = Number(child.product?.discount_amount) || 0;
                    const childTaxes = child.product?.extra_taxes || 0;
                    const childAmount = childPrice * childQuantity;
                    const childVatAmount = childVatRate * childAmount;
    
                    newTotalPrice += childPrice;
                    newTotalQuantity += childQuantity;
                    newTotalNetValue += childAmount;
                    newTotalVat += childVatAmount;
                    newTotalDiscountPercentage += childDiscountPecentage;
                    newTotalDiscountAmount += childDiscountAmount;
                    newTotalTaxes += (childTaxes * quantity);
                    newTotalPoints += (childPoint * childQuantity);
                    totalItemsCount++;
                });
            }
        });
    
        newTotalPrice = Number(newTotalPrice.toFixed(2));
        newTotalQuantity = Number(newTotalQuantity.toFixed(2));
        newTotalNetValue = Number(newTotalNetValue.toFixed(2));
        newTotalVat = Number(newTotalVat.toFixed(2));
        newTotalPoints = Number(newTotalPoints.toFixed(2));
        newTotalTaxes = Number(newTotalTaxes.toFixed(2));
        let finalTotalPrice = newTotalNetValue + newTotalVat;
        let finalTotalPriceWithDiscount = (newTotalNetValue + newTotalVat) - newTotalDiscountAmount;
        let finalTotalWithCharges = finalTotalPriceWithDiscount + newTotalTaxes;
    
        const updatedCartData = {
            itemsCount: totalItemsCount,
            totalQuantity: newTotalQuantity,
            totalPoints: newTotalPoints,
            totalInitialPrice: newTotalNetValue,
            discountPercentage : newTotalDiscountPercentage,
            discountAmount : newTotalDiscountAmount,
            finalAmount : finalTotalWithCharges,
            totalTaxes: newTotalTaxes
        };
        setCartItemsData((prev) => ({ ...prev, ...updatedCartData }));
    
        const updatedVirtualCartData = {
            itemsCount: totalItemsCount,
            totalQuantity: newTotalQuantity,
            netAmount: newTotalNetValue,
            vats: newTotalVat,
            totalAmount: finalTotalPrice,
            totalPoints: newTotalPoints,
            discountPercentage : newTotalDiscountPercentage,
            discountAmount : newTotalDiscountAmount,
            finalAmount : finalTotalWithCharges,
            totalTaxes: newTotalTaxes
        };
        setVirtualCartItems((prev) => ({ ...prev, ...updatedVirtualCartData }));
    
        const updatedFinalCartData = {
            itemsCount: totalItemsCount,
            totalQuantity: newTotalQuantity,
            netAmount: newTotalNetValue,
            vats: newTotalVat,
            totalAmount: finalTotalPrice,
            discount: 0,
            transportationFee: 0,
            totalPoints: 0,
            discountPercentage : newTotalDiscountPercentage,
            discountAmount : newTotalDiscountAmount,
            finalAmount : finalTotalWithCharges,
            totalTaxes: newTotalTaxes
        };
        setFinalCartItems((prev) => ({ ...prev, ...updatedFinalCartData }));

        const productCodeArray = [];
        const staticQuantityArray = {};

        itemsArray.forEach((value) => {
            productCodeArray.push(value.product.item_code);
            staticQuantityArray[value.product.item_code] = value.quantity;
        
            if (value.children && value.children.length > 0) {
                value.children.forEach((child) => {
                    productCodeArray.push(child.product.item_code);
                    staticQuantityArray[child.product.item_code] = child.quantity;
                });
            }
        });

        setProductStaticQuantity(staticQuantityArray);
        setCartProductCode(productCodeArray);

        localStorage.setItem('co_customer', customerid);
        localStorage.setItem("intercool_cartData", JSON.stringify(itemsArray));
        localStorage.setItem("intercool_productCodes", JSON.stringify(productCodeArray));
        localStorage.setItem("intercool_staticQuantities", JSON.stringify(staticQuantityArray));
    };
    const handleParentRemove = async (data) => {
        if (!data || !data.id) {
            console.error("Invalid data received for removal", data);
            return;
        }
    
        setIsCartLoader(true);
    
        const prevInputs = {...inputs};
        let updatedItems = [...(prevInputs.items || [])];
        const parentIndex = updatedItems.findIndex(item => item.id === data.id);
    
        if (parentIndex !== -1) {
            if (data.product === 'remove' || data.quantity === 0) {
                updatedItems = updatedItems.filter(item => item.id !== data.id);
            } else {
                updatedItems[parentIndex].quantity = data.quantity;
    
                const parentBodyRequest = {
                    "tempcartid": cartId,
                    "productid": data.id,
                    "productcode": updatedItems[parentIndex].product.item_code,
                    "qty": data.quantity,
                    "price": updatedItems[parentIndex].product.productprice
                };
    
                const updateParent = async () => {
                    const taxResponse = await getProductExtraTaxes(data.id);
                    const parentExtraTaxes = taxResponse?.nettaxvalue || 0;
                    const cartResponse = await getNewCartDetail(parentBodyRequest);
                    const parentDiscountPercent = cartResponse?.discountPercent || 0;
                    const parentDiscountAmount = cartResponse?.discountAmount || 0;
                    const parentReferenceDocumentId = cartResponse?.id || 0;
    
                    updatedItems[parentIndex].product.discount = parentDiscountPercent;
                    updatedItems[parentIndex].product.discount_amount = parentDiscountAmount;
                    updatedItems[parentIndex].product.referencedocumentid = parentReferenceDocumentId;
                    updatedItems[parentIndex].product.extra_taxes = parentExtraTaxes;
    
                    if (updatedItems[parentIndex].children && updatedItems[parentIndex].children.length > 0) {
                        const childUpdates = updatedItems[parentIndex].children.map(async (child) => {
                            const childBodyRequest = {
                                "tempcartid": cartId,
                                "productid": child.id,
                                "productcode": child.product.item_code,
                                "qty": data.quantity,
                                "price": child.product.productprice
                            };
    
                            const taxResponse = await getProductExtraTaxes(child.id);
                            const childExtraTaxes = taxResponse?.nettaxvalue || 0;
                            const childResponse = await getNewCartDetail(childBodyRequest);
                            const childDiscountPercent = childResponse?.discountPercent || 0;
                            const childDiscountAmount = childResponse?.discountAmount || 0;
                            const childReferenceDocumentId = childResponse?.id || 0;
    
                            return {
                                ...child,
                                quantity: data.quantity,
                                product: {
                                    ...child.product,
                                    discount: childDiscountPercent,
                                    discount_amount: childDiscountAmount,
                                    referencedocumentid: childReferenceDocumentId,
                                    extra_taxes: childExtraTaxes
                                }
                            };
                        });
    
                        const updatedChildren = await Promise.all(childUpdates);
                        updatedItems[parentIndex].children = updatedChildren;
                    }
                };
    
                await updateParent();
            }
        }
        calculateBundleSummary(updatedItems);
        setInputs({
            ...prevInputs,
            items: updatedItems,
            filteredItems: updatedItems,
        });
        setIsCartLoader(false);
    };
    // normal
    const calculateSummary = (itemsArray) => {
        let newtotalQuantity = 0;
        let newtotalVat = 0;
        let newtotalNetValue = 0;
        let newtotalPoints = 0;
        let transportationFee = 0;

        itemsArray.map((obj, index) => {
            const quantity = obj.quantity;
            const price = obj.product.productprice;
            const vat = (obj.product.vat_percentage / 100);
            const point = obj.product.loyalty_point;
            const amount = price * quantity;

            newtotalQuantity += parseFloat(quantity.toFixed(2));
            newtotalNetValue += parseFloat(amount.toFixed(2));
            newtotalVat += parseFloat((vat * amount).toFixed(2));
            newtotalPoints += (point * quantity);
        });

        let newFinalTotalQuantity = parseFloat(newtotalQuantity.toFixed(2));
        let newFinalTotalPoints = newtotalPoints;
        let newFinalTotalVat = parseFloat(newtotalVat.toFixed(2));
        let newFinalTotalNetValue = parseFloat(newtotalNetValue.toFixed(2));
        let finalTransportationFee = transportationFee;
        let finalFinalTotalPrice = newFinalTotalVat + newFinalTotalNetValue + finalTransportationFee; 

        setCartItemsData({
            ...cartItemsData,
            "itemsCount" : itemsArray.length,
            "totalQuantity" : newFinalTotalQuantity,
            "totalPoints" : newFinalTotalPoints,
            "totalInitialPrice" : newFinalTotalNetValue,
            "discountPercentage" : 0,
            "discountAmount" : 0,
            "finalAmount" : 0,
            "totalTaxes": 0
        });

        setVirtualCartItems({
            ...virtualCartItems,
            "itemsCount" : itemsArray.length,
            "totalQuantity" : newFinalTotalQuantity,
            "netAmount" : newFinalTotalNetValue,
            "vats" : newFinalTotalVat,
            "totalAmount" : finalFinalTotalPrice,
            "totalPoints" : newFinalTotalPoints,
            "discountPercentage" : 0,
            "discountAmount" : 0,
            "finalAmount" : 0,
            "totalTaxes": 0
        });

        setFinalCartItems({
            ...finalCartItems,
            "itemsCount" : itemsArray.length,
            "totalQuantity" : newFinalTotalQuantity,
            "netAmount" : newFinalTotalNetValue,
            "vats" : newFinalTotalVat,
            "totalAmount" : finalFinalTotalPrice,
            "discount" : 0,
            "transportationFee" : 0,
            "totalPoints" : 0,
            "discountPercentage" : 0,
            "discountAmount" : 0,
            "finalAmount" : 0,
            "totalTaxes": 0
        });
    };
    const finalCalculateSummary = (resData) => {
        let filteredCart = [];

        let newtotalQuantity = 0;
        let newtotalVat = 0;
        let newtotalNetValue = 0;
        let newtotalPoints = 0;
        let transportationFee = 0;

        let newtotalQuantity1 = 0;
        let newtotalVat1 = 0;
        let newtotalNetValue1 = 0;
        let newtotalPoints1 = 0;
        let transportationFee1 = 0;

        if(resData.length > 0) {
            resData.map((value, index) => {
                const quantity = value.QTY1;
                const price = value.UnitPrice;
                const vat = (value.vat_percent / 100);
                const point = 0;
                const amount = price * quantity;
    
                newtotalQuantity += parseFloat(quantity.toFixed(2));
                newtotalNetValue += parseFloat(amount.toFixed(2));
                newtotalVat += parseFloat((vat * amount).toFixed(2));
                newtotalPoints += (point * quantity);
    
                if(!cartProductCode.includes(value.item_code)) {
                    const quantity1 = value.QTY1;
                    const price1 = value.UnitPrice;
                    const vat1 = (value.vat_percent / 100);
                    const point1 = 0;
                    const amount1 = price1 * quantity1;
                    value.iscalculateditem = true;
        
                    newtotalQuantity1 += parseFloat(quantity1.toFixed(2));
                    newtotalNetValue1 += parseFloat(amount1.toFixed(2));
                    newtotalVat1 += parseFloat((vat1 * amount1).toFixed(2));
                    newtotalPoints1 += (point1 * quantity1);
    
                    filteredCart.push(value);
                } else {
                    value.iscalculateditem = false;
                }
            });
            setCalculateApiCart(resData);
            localStorage.setItem('co_calculate', JSON.stringify(resData));
            localStorage.setItem('co_calculate_filter', JSON.stringify(filteredCart));
    
            let newFinalTotalQuantity1 = parseFloat(newtotalQuantity1.toFixed(2));
            let newFinalTotalPoints1 = newtotalPoints1;
            let newFinalTotalVat1 = parseFloat(newtotalVat1.toFixed(2));
            let newFinalTotalNetValue1 = parseFloat(newtotalNetValue1.toFixed(2));
            let finalTransportationFee1 = transportationFee1;
            let finalFinalTotalPrice1 = newFinalTotalVat1 + newFinalTotalNetValue1 + finalTransportationFee1; 
    
            let newFinalTotalQuantity = parseFloat(newtotalQuantity.toFixed(2));
            let newFinalTotalPoints = newtotalPoints;
            let newFinalTotalVat = parseFloat(newtotalVat.toFixed(2));
            let newFinalTotalNetValue = parseFloat(newtotalNetValue.toFixed(2));
            let finalTransportationFee = transportationFee;
            let finalFinalTotalPrice = newFinalTotalVat + newFinalTotalNetValue + finalTransportationFee; 
    
            setCalculateItems(filteredCart);
            setFilterCalculateItems(filteredCart);
    
            setCalculateCartItems({
                ...calculateCartItems,
                "itemsCount" : filteredCart.length,
                "totalQuantity" : newFinalTotalQuantity1,
                "netAmount" : newFinalTotalNetValue1,
                "vats" : newFinalTotalVat1,
                "totalAmount" : finalFinalTotalPrice1,
                "totalPoints" : newFinalTotalPoints1,
                "discountPercentage" : 0,
                "discountAmount" : 0,
                "finalAmount" : 0,
                "totalTaxes": 0
            });
            setFinalCartItems({
                ...finalCartItems,
                "itemsCount" : resData.length,
                "totalQuantity" : newFinalTotalQuantity,
                "netAmount" : newFinalTotalNetValue,
                "vats" : newFinalTotalVat,
                "totalAmount" : finalFinalTotalPrice,
                "discount" : 0,
                "transportationFee" : finalTransportationFee1,
                "totalPoints" : newFinalTotalPoints,
                "discountPercentage" : 0,
                "discountAmount" : 0,
                "finalAmount" : 0,
                "totalTaxes": 0
            });
        }
    };
    const calculateItemsAmount = async (e) => {
        e.preventDefault();
        setCalculateButton(true);
        setShowCalculating(true);
        setReCalculate(true);

        setCalculateItems([]);
        setFilterCalculateItems([]);
        
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
        const calculateData = {
            "customer": {
                "customer_code": customerData.code,
                "document_date": deliveryDate,
                "payment_type": paymentMethod,
                "DATA": {
                    "PRODUCTLINES": calculateJson
                }
            }
        }

        logEvent('create_order_page', 'cart', 'calculate-cart', calculateData);
        await axios.post(baseUrl+"/api/edi/SvcQuotation?erp_int=B2BWEB", calculateData, { headers })
        .then((response) => {
            if(response.data.customer) {
                let resData = response.data.customer.DATA.PRODUCTLINES;
                finalCalculateSummary(resData);
                localStorage.setItem('co_calculate_button', 1);
            } else {
                setCalculateApiCart([]);
            }
            setShowCalculating(false);
        }).catch((error) => {
            console.log(error);
            setShowCalculating(false);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const handleLinkDataFromChild = (data) => {
        let itemCheck = inputs.items;
        itemCheck.map((value, index) => {
            if(value.product.item_code === data) {
                value.quantity = value.suggestQty;
                const requestData = [
                    {
                        "customerID": customerid,
                        "productID": data.id,
                        "qty": value.suggestQty,
                        "latGPS": ipData.latitude,
                        "longGPS": ipData.longitude,
                        "deviceID": ipData.ip,
                        "productPrice": value.product.productprice,
                        "discountPercent": value.product.discount,
                        "type": "add",
                        "screen": "b2b",
                        "couriertransactionid": 0
                    }
                ];
                sendCartProduct(requestData);
            }
        })
        const itemsArray = inputs.items;

        setInputs({
            ...inputs,
            'items' : itemsArray,
            'filteredItems' : itemsArray
        });
        calculateSummary(itemsArray);
        if(isCalculate) {
            setCalculateButton(false);
        }

        const calculateArrayJson = [];
        const productCodeArray = [];
        const staticQuantityArray = {};
        const staticMessageArray = {};

        let linenum = 1;
        itemsArray.map((value, index) => {
            if(value.quantity > 0 && value.quantity !== NaN) {
                var productLines = {
                    "LINENUM": linenum,
                    "vat_code": value.product.vat_code,
                    "MU": value.product.baseUnitOfMeasure ? value.product.baseUnitOfMeasure : 0,
                    "item_code": value.product.item_code,
                    "QTY1": value.quantity,
                    "UnitPrice": value.product.productprice,
                    "discount_pct": value.product.discount ? value.product.discount : 0,
                    "product_name": value.product.productname,
                    "vat_percent": value.product.vat_percentage
                }
                linenum++;
                calculateArrayJson.push(productLines);
                productCodeArray.push(value.product.item_code);
                staticQuantityArray[value.product.item_code] = value.quantity;
                if(data !== value.product.item_code) {
                    staticMessageArray[value.product.item_code] = value.message;
                }
            }
        });

        setProductStaticQuantity(staticQuantityArray);
        setProductStaticMessage(staticMessageArray);
        setCartProductCode(productCodeArray);
        setCalculateJson(calculateArrayJson);
        setCalculateItems([]);
        setFilterCalculateItems([]);
        localStorage.setItem('co_quantity', JSON.stringify(staticQuantityArray));
        localStorage.setItem('co_qty_message', JSON.stringify(staticMessageArray));
        localStorage.setItem('co_items', JSON.stringify(itemsArray));
        localStorage.setItem('co_code', JSON.stringify(productCodeArray));
        localStorage.setItem('co_calculate_json', JSON.stringify(calculateArrayJson));
        localStorage.setItem('co_customer', customerid);
    };
    const handleFilterItemsSortDataFromChild = (data) => {
        setFilterCalculateItems(data);
    };
    // submit
    const validateValues = (inputValues) => {
        let errors = {};

        if (inputValues.items.length === 0) {
            errors.items = true;
        }
        return errors;
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        getOrderSeriesList(baseUrl, token, customerData.partnerid);

        if (Object.keys(validateValues(inputs)).length === 0 && deliveryDate.length > 0 && paymentMethod.trim().length > 0) {
            Swal.fire({
                title: `${ t("are you sure")}?`,
                text: `${ t("you want to create new order")}!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `${ t("yes")}!`,
                cancelButtonText: `${ t("cancel")}!`
            }).then((result) => {
                if (result.isConfirmed) {
                    setFormButton(true);
                    var currentdate = new Date(); 
                    var datetime = currentdate.getHours() + ":" + currentdate.getMinutes() + ":" + currentdate.getSeconds();

                    const baseUrl = env.REACT_APP_API_URL;
                    const token = localStorage.getItem('token');
                    const headers = {
                        "Accept" : "Application/json",
                        "Content-Type" : "Application/json",
                        "Authorization" : `Bearer ${token}`
                    };

                    const items = [];
                    inputs.items.forEach((item, index) => {
                        const prepareProductData = (product, quantity) => {
                            const productPrice = parseFloat(product.productprice);
                            const productVat = (product.vat_percentage / 100);
                            const productTax = product.extra_taxes;
                            const productTotalNetValue = quantity * productPrice;
                            const productDiscount = product.discount_amount;
                            const productTotalTax = productTax * quantity;
                            const productTotalVat = productTotalNetValue * productVat;
                            const productTotalAmount = (productTotalNetValue + productTotalVat + productTotalTax) - productDiscount;

                            return {
                                OrderDetailID: 0,
                                discount_amount: productDiscount,
                                init_price: productPrice,
                                percent_discount: product.discount,
                                points: 0,
                                product_id: product.productid,
                                product_code: product.item_code,
                                quantity: quantity,
                                serial_no: 0,
                                sub_total: productTotalNetValue.toFixed(2),
                                total: productTotalAmount.toFixed(2),
                                vat_amount: productTotalVat.toFixed(2),
                                free_qty: 0,
                                Netamount: productTotalNetValue.toFixed(2),
                                discount_amount1: 0,
                                discount_amount2: 0,
                                discount_amount3: 0,
                                discount_amount4: 0,
                                discount_amount5: 0,
                                totalDiscount_amount: 0,
                                discount_pct1: 0,
                                discount_pct2: 0,
                                discount_pct3: 0,
                                discount_pct4: 0,
                                discount_pct5: 0,
                                listpriceamount: 0,
                                customerdicountpct: 0,
                                priceamount: productPrice,
                                stock_qty: 0,
                                unit_cost: 0,
                                StockDetailID: 0,
                                iscalculateditem: false,
                                referencedocumentid: product.referencedocumentid,
                                extra_taxes: productTotalTax.toFixed(2)
                            };
                        };
                        items.push(prepareProductData(item.product, item.quantity));
                        if (item.children && item.children.length > 0) {
                            item.children.forEach(child => {
                                items.push(prepareProductData(child.product, child.quantity));
                            });
                        }
                    });

                    var totalAmount = virtualCartItems.totalAmount;
                    var netAmount = virtualCartItems.netAmount;
                    var totalQuantity = virtualCartItems.totalQuantity;
                    var totalPoints = virtualCartItems.totalPoints;
                    var vats = virtualCartItems.vats;
                    var totalDiscountAmount = virtualCartItems.discountAmount;
                    var totalDiscountPercentage = virtualCartItems.discountPercentage;
                    var totalFinalAmount = virtualCartItems.finalAmount;
                    var totalTaxes = virtualCartItems.totalTaxes;

                    const requestData = [];
                    items.map((item, index) => {
                        requestData.push({
                            "customerID": customerid,
                            "productID": item.product_id,
                            "qty":  item.quantity,
                            "latGPS": ipData.latitude,
                            "longGPS": ipData.longitude,
                            "deviceID": ipData.ip,
                            "productPrice": item.init_price,
                            "discountPercent": item.percent_discount,
                            "type": "add",
                            "screen": "b2b",
                            "couriertransactionid": 0,
                            "cartnumber": uniqueKey,
                            "referencedocumentid": cartId
                        });
                    })
                    sendCartProduct(requestData);

                    let data = {
                        OrderID: 0,
                        BankID: "",
                        ChequeExpiryDate: "",
                        ChequeNo: "",
                        CustomerID: parseInt(customerid),
                        customerAddressID: 0,
                        customerAddressCode: "",
                        Mobile_App_Version12: "",
                        Mobile_User_Mac_Address: "",
                        PaymentDate: "",
                        PaymentType: paymentMethod,
                        PaymentTypeID: paymentTypeId,
                        total_tax_amount: totalTaxes,
                        comment: comment,
                        delivery_date: moment(deliveryDate).format("DD-MM-YYYY"),
                        discount_amount: totalDiscountAmount,
                        final_amount: (totalFinalAmount + shippingCost),
                        orderCode: "",
                        percent_discount: totalDiscountPercentage,
                        sub_total: netAmount,
                        tid: "",
                        total_ChargeProduct: 0,
                        total_gift_quantity: 0,
                        total_pieces: totalQuantity,
                        total_points: totalPoints,
                        total_transportation: shippingCost,
                        transactionDate: "",
                        transactionId: "",
                        vat_amount: vats,
                        Discount_Redeem_Product_ID: 0,
                        total_free_qty: 0,
                        Order_status: "Draft",
                        StockOrderID: 0,
                        StartTime: datetime, 
                        EndTime: datetime, 
                        Latitude: "",
                        Longitude: "",
                        newTotalPointBalance: 0,
                        OrderSeriesID: inputs.orderSeries,
                        OrderSeriesNumber:  inputs.orderSeriesLastNumber+1,
                        CourierTransactionID: 0,
                        iscalculated: false,
                        create_order: true,
                        items: items,
                        personid: personId,
                        transportation_company_id: transportationCompanyId,
                        cartnumber: uniqueKey
                    };

                    if(customerData.minimumcharge > 0 && customerData.minimumcharge > totalAmount) {
                        Swal.fire({
                            title: `${ t("warning")}!`,
                            text: `${ t("order total value can not be less than") + " "+ customerData.minimumcharge}!`,
                            icon: "warning"
                        });
                        setFormButton(false);
                        logEvent('create_order_page', 'cart', 'place_order', 'failed_min_order');
                    } else {
                        axios.post(baseUrl+"/api/Product/PlaceOrder", data, { headers })
                        .then((response) => {
                            if(response.data.success === "1") {
                                logEvent('create_order_page', 'cart', 'place_order', 'success_id_'+response.data.orderID);
                                clearData();
                                clearCartStorage();
                                Swal.fire({
                                    title: `${ t("order created")}!`,
                                    text: `${ t("your order is added with the number") + " "+ response.data.orderID}!`,
                                    icon: "success"
                                });
                                setFormButton(false);
                            } else {
                                Swal.fire({
                                    title: `${ t("oops")}!`,
                                    text: `${ t("something went wrong")}!`,
                                    icon: "warning",
                                });
                                setFormButton(false);
                            }
                        }).catch((error) => {
                            setFormButton(false);
                            Swal.fire({
                                title: `${ t("oops")}!`,
                                text: `${ t("something went wrong")}!`,
                                icon: "warning",
                            });
                        });
                    }
                }
            });
        }
    };

    return (
        <div className="relative">
            <Layout sendTabCheckDataFromChild={handleTabCheckDataFromChild}> 
                <div className="space-y-2 sm:space-y-4">
                    {/* first box */}
                    <div className="sm:flex sm:justify-between sm:items-center">
                        <div>
                            <h1 className="sm:text-2xl font-semibold capitalize">{ t('create order') }</h1>
                            <p className="text-light-400 text-xs sm:text-sm capitalize"><NavLink to="/order/history" >{ t('orders') }</NavLink> / <NavLink to={`/order/history/${id}`} >{ t('order detail') }</NavLink> / { t('order again') }</p>
                        </div>
                        <div className="mt-2 sm:mt-0 flex items-center justify-end space-x-2">
                            <div>
                                <button onClick={(e) => handleClearData(e)} className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg tracking-wide capitalize">{ t('clear')}</button>
                            </div>
                        </div>
                    </div>
                    { isLoader 
                        ? 
                            <LoaderIcon /> 
                        :
                            <div className={(showTab === 'product-list') ? "space-y-2" : "space-y-2 sm:space-y-4"}>
                                {/* first box */}
                                <div className="p-2 sm:p-4 bg-white border border-white rounded-lg space-y-4">
                                    <div className="lg:flex lg:space-x-2 lg:justify-between space-y-4 lg:space-y-0">
                                        <div className={(showTab === "summary") ? "lg:w-[45%]" : "lg:w-[30%]"}>
                                            <div>
                                                <h1 className="font-semibold lg:text-lg">{customerData.name}</h1>
                                            </div>
                                            <div>
                                                <div className="font-normal text-xs lg:text-sm text-gray-dark capitalize">
                                                    { t('customer code') }: {customerData.code}
                                                </div>
                                                {customerData.address ? 
                                                    <div className="flex items-center text-sm">
                                                        <div className="flex">
                                                            <img src="../../../../assets/icons/location.svg" alt="mail" />
                                                            <div className="text-gray-dark ml-1">{customerData.address}</div>
                                                        </div>
                                                    </div>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                        <div className={((showTab === "summary") ? "lg:w-[55%]" : "lg:w-[70%]") + " hidden sm:block"}>
                                            {(showTab === 'order-type' || showTab === 'common-items' || showTab === 'made-for-you' || showTab === 'product-list') 
                                                ? 
                                                    <CartBox cartItemsData={cartItemsData} uniqueKey={uniqueKey}  /> 
                                                :
                                                (showTab === "summary") ?
                                                    <div className="border border-blue-light2 bg-blue-light2 rounded-md p-4 space-y-2">
                                                        <h1 className="text-sm md:text-base text-light-400 first-letter:capitalize">select option(s)</h1>
                                                        <div className="flex space-x-4">
                                                            <div key="company" className="flex justify-start items-center">
                                                                <label className="relative flex items-center cursor-pointer">
                                                                    <input type="checkbox" name="company" value="company" checked={isCompanyChecked} onChange={() => setIsCompanyChecked(!isCompanyChecked)} className="before:content[''] peer relative h-6 w-6 bg-white cursor-pointer appearance-none rounded border border-black-100 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-6 before:w-6 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                                    <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                                        </svg>
                                                                    </span>
                                                                </label>
                                                                <div className="font-normal text-xs sm:text-sm capitalize ml-2">{ t('transportation company')}</div>
                                                            </div>
                                                            <div key="address" className="flex justify-start items-center">
                                                                <label className="relative flex items-center cursor-pointer">
                                                                    <input type="checkbox" name="address" value="address" checked={isAddressChecked} onChange={() => setIsAddressChecked(!isAddressChecked)} className="before:content[''] peer relative h-6 w-6 bg-white cursor-pointer appearance-none rounded border border-black-100 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-6 before:w-6 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                                    <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                                        </svg>
                                                                    </span>
                                                                </label>
                                                                <div className="font-normal text-xs sm:text-sm capitalize ml-2">{ t('customer address')}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                :
                                                <VirtualCartBox finalCartItems={finalCartItems} uniqueKey={uniqueKey} />
                                            } 
                                        </div>
                                    </div>
                                    <div className="flex justify-between md:justify-normal space-x-3 md:space-x-6 overflow-auto no-scrollbar">
                                        <div onClick={(e) => openTab(e, 'common-items')} className={(showTab === "common-items" ? activeTab : "text-gray-dark") + " cursor-pointer text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('common items') }</span></div>
                                        <div onClick={(e) => openTab(e, 'made-for-you')} className={(showTab === "made-for-you" ? activeTab : "text-gray-dark") + " cursor-pointer text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('made for you') }</span></div>
                                        <div onClick={(e) => openTab(e, 'product-list')} className={(showTab === "product-list" ? activeTab : "text-gray-dark") + " cursor-pointer text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('products list') }</span></div>
                                        <div onClick={inputs.items.length > 0 ? (e) => openTab(e, 'cart') : null} className={(showTab === "cart" ? activeTab : "text-gray-dark") + (inputs.items.length === 0 ? " cursor-not-allowed " : " cursor-pointer ")  + " text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('cart') }</span></div>
                                        <div onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={(showTab === "summary" ? activeTab : "text-gray-dark") + (((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? " cursor-pointer " : " cursor-not-allowed ") + " text-center text-xs sm:text-base font-semibold capitalize"}><span className="flex w-max">{ t('summary') }</span></div>
                                    </div>
                                </div>
                                <div className="block sm:hidden p-2 sm:p-4 bg-white border border-white rounded-lg space-y-2 sm:space-y-4">
                                    {(showTab === 'order-type' || showTab === 'common-items' || showTab === 'made-for-you' || showTab === 'product-list') 
                                        ? 
                                            <CartBox cartItemsData={cartItemsData} uniqueKey={uniqueKey}  /> 
                                        :
                                        (showTab === "summary") ?
                                            <div className="border border-blue-light2 bg-blue-light2 rounded-md p-4 space-y-2">
                                                <h1 className="text-sm md:text-base text-light-400 first-letter:capitalize">select option(s)</h1>
                                                <div className="flex space-x-4">
                                                    <div key="company" className="flex justify-start items-center">
                                                        <label className="relative flex items-center cursor-pointer">
                                                            <input type="checkbox" name="company" value="company" checked={isCompanyChecked} onChange={() => setIsCompanyChecked(!isCompanyChecked)} className="before:content[''] peer relative h-6 w-6 bg-white cursor-pointer appearance-none rounded border border-black-100 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-6 before:w-6 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                            <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                                </svg>
                                                            </span>
                                                        </label>
                                                        <div className="font-normal text-xs sm:text-sm capitalize ml-2">{ t('transportation company')}</div>
                                                    </div>
                                                    <div key="address" className="flex justify-start items-center">
                                                        <label className="relative flex items-center cursor-pointer">
                                                            <input type="checkbox" name="address" value="address" checked={isAddressChecked} onChange={() => setIsAddressChecked(!isAddressChecked)} className="before:content[''] peer relative h-6 w-6 bg-white cursor-pointer appearance-none rounded border border-black-100 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-6 before:w-6 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                            <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                                </svg>
                                                            </span>
                                                        </label>
                                                        <div className="font-normal text-xs sm:text-sm capitalize ml-2">{ t('customer address')}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        :
                                        <VirtualCartBox finalCartItems={finalCartItems} uniqueKey={uniqueKey} />
                                    } 
                                </div>
                                <div>
                                    { showTab === 'common-items' && 
                                        <div className="p-2 sm:p-4 bg-white border border-white rounded-lg space-y-2 sm:space-y-4 relative">
                                            <div className="sm:flex sm:justify-between sm:items-center sm:space-x-2 space-y-2 sm:space-y-0">
                                                <SearchBar placeholder={t('search')+"..."} term={searchCommonItemsTerm} setSearchDataFromChild={handleCommonSearchDataFromChild}/>
                                                <div className="flex items-center justify-end space-x-2">
                                                    {(filterInputsOne.productCode.length > 0 || filterInputsOne.description.length > 0 || filterInputsOne.categoryNameArray.length > 0 || filterInputsOne.productGroupNameArray.length > 0) ? 
                                                        <div className="relative flex sm:hidden flex-col items-center group">
                                                            <div className="border border-blue-normal rounded-xl cursor-pointer bg-white py-1.5 px-2">
                                                                <img className="w-6 h-6" src="../../../../assets/icons/table/filter-eye.png" alt="eye" />
                                                            </div>
                                                            <FilterDataHover filter={filterInputsOne} />
                                                        </div>
                                                    : null}
                                                    <div ref={dropdownRef3} className="relative"> 
                                                        <div className="sm:hidden flex w-fit items-center cursor-pointer bg-black-300 rounded-lg py-2 px-3 sm:px-4" onClick={(e) => handleShowSort(e, 'one')}>
                                                            <img className="w-6 h-6" src="../../../../assets/icons/table/sort.svg" alt="sort" />
                                                        </div>
                                                        {
                                                            showSortOne 
                                                            ?
                                                                <ul className="z-20 py-3 bg-white top-14 absolute right-0 border border-white shadow-md rounded-[10px] w-52 text-left h-40 overflow-y-auto no-scrollbar">
                                                                    {sortTypesList.map((value, index) => (
                                                                        <li key={index} onClick={(e) => handleSortTypeOneDataFromChild((e), value)} className={(sortCommonItemsName === value.name ? "bg-action-hover" : "bg-white") + " hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-xs"}>{ t(value.name)}</li>
                                                                    ))}
                                                                </ul>
                                                            : null
                                                        }
                                                    </div>
                                                    <div ref={dropdownRef} className="relative">
                                                        <div className="flex w-fit text-right items-center cursor-pointer bg-black-300 rounded-lg py-3 sm:py-2 px-4" onClick={(e) => handleShowFilter(e, 'one')}>
                                                            <div>
                                                                <img className="w-3.5 sm:w-4" src="../../../../assets/icons/table/filter.svg" alt="filter" />
                                                            </div>
                                                            <div className="hidden sm:block ml-2 text-blue-normal font-medium text-xl capitalize">{ t('filter')}</div>
                                                        </div>
                                                        {
                                                            showFilterOne 
                                                            ?
                                                                <FilterFormLayout>
                                                                    <form onSubmit={(e) => handleFilterSubmit(e, 'one')}>
                                                                        <div className="px-2 sm:px-4 space-y-2 sm:space-y-4">
                                                                            <div>
                                                                                <label className="font-medium capitalize text-sm sm:text-base">{ t('product category')}</label>
                                                                                <div className="inline-block relative w-full mt-1">
                                                                                    <button type="button" onClick={(e) => handleShowCategory(e, 'one')} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base py-2 px-3 rounded-md inline-flex items-center">
                                                                                        <span className="text-gray-dark capitalize mr-1 text-xs sm:text-base">{filterInputsOne.categoryIdArray.length > 0 ? t('filter is applied') : t('select category')}</span>
                                                                                        <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                                    </button>
                                                                                    {
                                                                                        showCategoryOne
                                                                                        ? 
                                                                                            <ul className="absolute w-full min-h-auto max-h-44 overflow-y-auto no-scrollbar z-30 text-background-dark bg-white shadow-md rounded-md">
                                                                                                <CategoryCheckbox parentData={filterInputsOne.categoryIdArray} categoryList={categoryListOne} sendCategoryDataFromChild={handleCategoryOneDataFromChild}/>
                                                                                            </ul>                            
                                                                                        : null
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <label className="font-medium capitalize text-sm sm:text-base">{ t('product group a')}</label>
                                                                                <div className="inline-block relative w-full mt-1">
                                                                                    <button type="button" onClick={(e) => handleShowProductGroup(e, 'one')} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base py-2 px-3 rounded-md inline-flex items-center">
                                                                                        <span className="text-gray-dark capitalize mr-1 text-xs sm:text-base">{filterInputsOne.productGroupIdArray.length > 0 ? t('filter is applied') : t('select product group')}</span>
                                                                                        <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                                    </button>
                                                                                    {
                                                                                        showProductGroupOne
                                                                                        ? 
                                                                                            <ul className="absolute w-full min-h-auto max-h-44 overflow-y-auto no-scrollbar z-20 text-background-dark bg-white shadow-md rounded-md">
                                                                                                <ProductGroupCheckbox parentData={filterInputsOne.productGroupIdArray} productGroupList={productGroupList} sendProductGroupDataFromChild={handleProductGroupOneDataFromChild}/>
                                                                                            </ul> 
                                                                                        : null
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <label className="font-medium capitalize text-sm sm:text-base">{ t('product code')}</label>
                                                                                <div className="inline-block relative w-full mt-1">
                                                                                    <input type="text" name="productCode" value={filterInputsOne.productCode} onChange={(e) => handleChange(e, 'one')} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("product code")} />
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <label className="font-medium capitalize text-sm sm:text-base">{ t('description')}</label>
                                                                                <div className="inline-block relative w-full mt-1">
                                                                                    <textarea type="text" name="description" value={filterInputsOne.description} onChange={(e) => handleChange(e, 'one')} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("description")} >{filterInputsOne.description}</textarea>
                                                                                </div>
                                                                            </div>
                                                                            <div className="flex items-center justify-end my-2">
                                                                                <div>
                                                                                    <button onClick={(e) => clearFilterData(e, "one")} type="button" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg capitalize">{ t('clear')}</button>
                                                                                </div>
                                                                                <div className="ml-4">
                                                                                    <button type="submit" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg capitalize">{ t('apply')}</button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </form>
                                                                </FilterFormLayout>
                                                            : null
                                                        }
                                                    </div>
                                                    {(filterInputsOne.productCode.length > 0 || filterInputsOne.description.length > 0 || filterInputsOne.categoryNameArray.length > 0 || filterInputsOne.productGroupNameArray.length > 0) ? 
                                                        <div className="hidden relative sm:flex flex-col items-center group">
                                                            <div className="border border-blue-normal rounded-xl cursor-pointer bg-white py-1.5 px-2">
                                                                <img className="w-6 h-6" src="../../../../assets/icons/table/filter-eye.png" alt="eye" />
                                                            </div>
                                                            <FilterDataHover filter={filterInputsOne} />
                                                        </div>
                                                    : null}
                                                </div>
                                            </div>
                                            {isCommonTableLoader ? <TableLoaderIcon /> : (commonItems.list.length > 0) ?
                                                <>
                                                    <div className="sm:block hidden mt-4 relative overflow-x-auto shadow-md rounded-lg">
                                                        <table className="w-full text-xs">
                                                            <thead className="text-gray-normal bg-background-normal">
                                                                <tr>
                                                                    <th scope="col" className="font-normal p-4 w-[40%]">
                                                                        <div className="flex">
                                                                            <div className="mr-2 uppercase">
                                                                                { t('product name')}
                                                                            </div>
                                                                            <SortData fieldName={'productname'} setSortDataFromChild={handleCommonItemsSortDataFromChild} />
                                                                        </div>
                                                                    </th>
                                                                    <th scope="col" className="font-normal p-4">
                                                                        <div className="flex">
                                                                            <div className="mr-2 uppercase">
                                                                                { t('price')}
                                                                            </div>
                                                                            <SortData fieldName={'price'} setSortDataFromChild={handleCommonItemsSortDataFromChild} />
                                                                        </div>
                                                                    </th>
                                                                    <th scope="col" className="font-normal p-4">
                                                                        <div className="flex">
                                                                            <div className="mr-2 uppercase">
                                                                                { t('m/m')}
                                                                            </div>
                                                                            <SortData fieldName={'unit'} setSortDataFromChild={handleCommonItemsSortDataFromChild} />
                                                                        </div>
                                                                    </th>
                                                                    <th scope="col" className="font-normal p-4 text-left uppercase">
                                                                        { t('add item')}
                                                                    </th>
                                                                    <th scope="col" className="font-normal p-4 text-left uppercase">
                                                                        { t('message')}
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {(commonItems.list).map((row, index) => (
                                                                    <tr key={row.productid} className="bg-white border-b hover:bg-gray-50">
                                                                        <td className="py-4 px-2 font-semibold w-[45%]">
                                                                            <div className="flex">
                                                                                <div className="w-14 lg:w-auto">
                                                                                    <img className="w-8 h-8" src={row.image ? row.image : defaultProductImage} alt="product-img" />
                                                                                </div>
                                                                                <div className="ml-2 grid justify-between">
                                                                                    <h1 className="lg:text-base tracking-wider">{row.b2bline1}</h1>
                                                                                    <div className="flex divide-x divide-gray-dark divide-solid items-center">
                                                                                        <div className="text-light-400 capitalize pr-2">{row.b2bline2}</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td className="py-4 px-2 text-light-400">
                                                                            {formatter.format(row.productprice)} €
                                                                        </td>
                                                                        <td className="py-4 px-2 text-light-400">
                                                                            {row.baseUnitOfMeasure ? row.baseUnitOfMeasure : 'NA'}
                                                                        </td>
                                                                        <td className="py-4 px-2 flex w-52 sm:flex-col sm:items-center sm:justify-center lg:flex-row">
                                                                            <AddQuantityButton row={row} sendQuantityDataFromChild={handleBundleQuantity} staticQuantityArray={productStaticQuantity[row.item_code] ? productStaticQuantity[row.item_code] : 0} popCheck={false} type={"table"} loading={isBundleLoading}/>
                                                                        </td>
                                                                        <td className="py-4 px-2 text-light-400">
                                                                            <MessageLink row={row} staticMessage={productStaticMessage[row.item_code]} sendLinkDataFromChild={handleLinkDataFromChild}/>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                        <Pagination
                                                            currentPage={rowCommonItemsCurrentPage}
                                                            totalCount={commonItems.total_record}
                                                            pageSize={rowsCommonItemsPerPage}
                                                            perPageCount={commonItems.list.length}
                                                            onPageChange={page => handleCommonItemsCurrentPage(page)}
                                                            onPageSizeChange={row => handleCommonItemsPerPage(row)}
                                                        />
                                                    </div>
                                                    <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3">
                                                        <div className="space-y-3 h-[25rem] overflow-y-auto no-scrollbar">
                                                            { commonItems.list.map((row, index) => (
                                                                <div key={row.productid}>
                                                                    <div className="grid space-y-2">
                                                                        <div className="flex">
                                                                            <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16" src={row.image ? row.image : defaultProductImage} alt="product" />
                                                                            <div className="ml-2 flex flex-col justify-between w-full">
                                                                                <div>
                                                                                    <div className="font-medium text-xs">{row.b2bline1}</div>
                                                                                    <div className="text-light-400 text-xs capitalize">{row.b2bline2}</div>
                                                                                </div>
                                                                                <div className="text-light-400 text-sm text-right">
                                                                                    <span className="capitalize">{ t('price')} : </span><span className="font-medium">{formatter.format(row.productprice)} €</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex justify-between items-center">
                                                                            <div className="text-light-400 text-xs">
                                                                                <div className="uppercase">{ t('m/m')} : </div><div className="font-medium">{row.baseUnitOfMeasure}</div>
                                                                            </div>
                                                                            <div className="flex">
                                                                                <AddQuantityButton row={row} sendQuantityDataFromChild={handleBundleQuantity} staticQuantityArray={productStaticQuantity[row.item_code] ? productStaticQuantity[row.item_code] : 0} popCheck={false} type={"box"} loading={isBundleLoading}/>
                                                                            </div>
                                                                        </div>
                                                                        <MessageLink row={row} staticMessage={productStaticMessage[row.item_code]} sendLinkDataFromChild={handleLinkDataFromChild}/>
                                                                    </div>
                                                                    <div className="my-3 border-t-2 border-background-normal"></div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <MobilePagination
                                                            currentPage={rowCommonItemsCurrentPage}
                                                            totalCount={commonItems.total_record}
                                                            pageSize={rowsCommonItemsPerPage}
                                                            perPageCount={commonItems.list.length}
                                                            onPageChange={page => handleCommonItemsCurrentPage(page)}
                                                            onPageSizeChange={row => handleCommonItemsPerPage(row)}
                                                        />
                                                    </div>
                                                </>
                                                : 
                                                <div className="p-2 sm:p-4 h-36 capitalize bg-white border border-white text-base sm:text-xl rounded-lg flex flex-col justify-center items-center font-semibold">
                                                    { t('no records available')}
                                                </div>
                                            }
                                            <div className="hidden sm:flex justify-between sm:justify-end sm:space-x-2">
                                                <div>
                                                    <button type="button" onClick={(inputs.items.length > 0) ? (e) => openTab(e, 'cart') : null} className={((inputs.items.length > 0) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                        { t('cart')}
                                                    </button>
                                                </div>
                                                <div>
                                                    <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                        { t('summary')}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="fixed z-50 flex bg-white p-2 sm:hidden justify-between bottom-0 w-full left-0">
                                                <div>
                                                    <button type="button" onClick={(inputs.items.length > 0) ? (e) => openTab(e, 'cart') : null} className={((inputs.items.length > 0) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                        { t('cart')}
                                                    </button>
                                                </div>
                                                <div>
                                                    <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                        { t('summary')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    { showTab === 'made-for-you'
                                        ? 
                                            <div className="p-2 sm:p-4 bg-white border border-white rounded-lg space-y-3">
                                                {madeForYouSectionList.length > 0 ?
                                                    madeForYouSectionList.map((section, key1) => (
                                                        <div key={'section'+key1} className="even:bg-white odd:bg-blue-light1">
                                                            <div className="border border-background-normal rounded-[10px] pl-2 sm:pl-4 py-2 sm:py-4 space-y-2 sm:space-y-4">
                                                                <h1 className="capitalize sm:text-lg md:text-3xl font-semibold text-center">{ section.section_title }</h1>
                                                                <p className="first-letter:capitalize text-xs md:text-base font-normal text-center">{ section.section_description }</p>
                                                                <div className="space-y-3 pr-2 sm:pr-4 max-h-[26rem] overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-gray-300">
                                                                    {(section.products) ? section.products.map((sectionProduct, key2) => (
                                                                        <div key={'sectionProduct'+key2}>
                                                                            <div className="my-3 border-t-2 border-background-normal"></div>
                                                                            <div className="grid sm:grid-cols-3 space-y-2 md:space-y-0">
                                                                                <div className="sm:col-span-2 flex">
                                                                                    <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16 sm:w-28 sm:h-28" src={sectionProduct.image ? sectionProduct.image : defaultProductImage} alt="product" />
                                                                                    <div className="ml-2 flex flex-col justify-between">
                                                                                        <div className="font-medium text-sm md:text-lg">{sectionProduct.productname}</div>
                                                                                        <div className="text-light-400 text-xs capitalize">{sectionProduct.productdescription}</div>
                                                                                        <div className="font-bold sm:text-xl text-right sm:text-left">{formatter.format(sectionProduct.productprice)} €</div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="flex justify-between sm:justify-evenly sm:flex-col items-center sm:items-end">
                                                                                    <div className="sm:flex sm:items-center sm:space-x-2 text-xs md:text-sm sm:justify-end space-y-1 sm:space-y-0">
                                                                                        <div className="sm:flex border border-black-100 rounded-lg bg-white text-light-400 p-2">
                                                                                            <div className="capitalize">{ t('units')} : </div>
                                                                                            <div className="font-medium">{formatter.format(sectionProduct.quantity_proposed)}</div>
                                                                                        </div>
                                                                                        <div className="sm:flex border border-black-100 rounded-lg bg-white text-light-400 p-2">
                                                                                            <div className="uppercase">{ t('m/m')} : </div>
                                                                                            <div className="font-medium">{sectionProduct.baseUnitOfMeasure}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="flex sm:w-52 justify-end">
                                                                                        <AddQuantityButton row={sectionProduct} sendQuantityDataFromChild={handleBundleQuantity} staticQuantityArray={productStaticQuantity[sectionProduct.item_code] ? productStaticQuantity[sectionProduct.item_code] : 0} popCheck={false} type={"box"} loading={isBundleLoading}/>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                    : 
                                                                        <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                                                            { t('no records available')}
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                : 
                                                    <div className="p-2 sm:p-4 h-20 capitalize bg-white border border-white rounded-lg text-base sm:text-xl flex flex-col justify-center items-center font-semibold">
                                                        { t('no deals available')}
                                                    </div>
                                                }
                                                <div className="hidden sm:block lg:flex lg:justify-between space-y-2 lg:space-y-0 items-center">
                                                    <div className=" border border-black-100 rounded-lg bg-white py-2 px-2 sm:px-4 text-xs sm:text-sm text-light-400 capitalize sm:w-fit">
                                                        <div className="flex divide-x-2 divide-gray-dark divide-solid"> 
                                                            <div className="sm:flex px-1.5 sm:px-3 text-light-400 items-center">
                                                                <h1 className="capitalize font-semibold text-xs sm:text-base">{ t('no. of items')}:</h1>
                                                                <div className="font-bold ml-0.5 pt-1 sm:ml-1">{cartItemsData.itemsCount}</div>
                                                            </div>
                                                            <div className="sm:flex px-1.5 sm:px-3 text-light-400 items-center">
                                                                <h1 className="capitalize font-semibold text-xs sm:text-base">{ t('total quantity')}:</h1>
                                                                <div className="font-bold ml-0.5 pt-1 sm:ml-1">{formatter.format(cartItemsData.totalQuantity)}</div>
                                                            </div>
                                                            <div className="sm:flex px-1.5 sm:px-3 text-light-400 items-center">
                                                                <h1 className="capitalize font-semibold text-xs sm:text-base">{ t('initial price')}:</h1>
                                                                <div className="font-bold ml-0.5 pt-1 sm:ml-1">{formatter.format(cartItemsData.totalInitialPrice)} €</div>
                                                            </div>
                                                        </div> 
                                                    </div>
                                                    <div className="grid grid-cols-3 gap-1 sm:gap-2 items-center">
                                                        <div  onClick={(e) => openTab(e, 'product-list')} className="text-blue-normal bg-white border border-blue-normal px-1 sm:px-2 py-2 rounded-lg w-full text-center capitalize cursor-pointer font-semibold text-[11px] sm:text-base">
                                                            { t('add more items')}
                                                        </div>
                                                        <div>
                                                            <button type="button" onClick={(inputs.items.length > 0) ? (e) => openTab(e, 'cart') : null} className={((inputs.items.length > 0) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " text-white px-1 sm:px-2 py-2 border rounded-lg text-center capitalize font-semibold text-[11px] sm:text-base w-full"}>
                                                                { t('cart')}
                                                            </button>
                                                        </div>
                                                        <div>
                                                            <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-full text-white px-1 sm:px-2 py-2 border rounded-lg text-center capitalize font-semibold text-[11px] sm:text-base"}>
                                                                { t('summary')}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="grid sm:hidden fixed z-50 left-0 bottom-0 p-2 bg-white rounded w-full grid-cols-3 gap-1 sm:gap-2 items-center">
                                                    <div onClick={(e) => openTab(e, 'product-list')} className="text-blue-normal bg-white border border-blue-normal px-1 sm:px-2 py-2 rounded-lg w-full text-center capitalize cursor-pointer font-semibold text-[11px] sm:text-base">
                                                        { t('add more items')}
                                                    </div>
                                                    <div>
                                                        <button type="button" onClick={(inputs.items.length > 0) ? (e) => openTab(e, 'cart') : null} className={((inputs.items.length > 0) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " text-white px-1 sm:px-2 py-2 border rounded-lg text-center capitalize font-semibold text-[11px] sm:text-base w-full"}>
                                                            { t('cart')}
                                                        </button>
                                                    </div>
                                                    <div>
                                                        <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-full text-white px-1 sm:px-2 py-2 border rounded-lg text-center capitalize font-semibold text-[11px] sm:text-base"}>
                                                            { t('summary')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        : null
                                    }
                                    {showTab === 'product-list' &&
                                        <div className="p-2 sm:p-4 bg-white border border-white rounded-lg space-y-2 sm:space-y-4">
                                            <div className="xl:flex xl:justify-between xl:items-center xl:space-x-2 space-y-2 xl:space-y-0">
                                                <SearchBar placeholder={t('search')+"..."} term={searchTerm} setSearchDataFromChild={handleCommonSearchDataFromChild}/>
                                                <div className="sm:flex sm:items-center sm:space-x-2 space-y-2 sm:space-y-0">
                                                    <CategorySubcategoryFilter filterCategoryList={filterCategoryList} filterSelectedData={filterSelectedData} onSelectionChange={handleSelectionChange} />
                                                    <div className="flex items-center justify-end space-x-2">
                                                        {(filterInputsTwo.productCode.length > 0 || filterInputsTwo.description.length > 0 || filterInputsTwo.categoryNameArray.length > 0 || filterInputsTwo.productGroupNameArray.length > 0) ? 
                                                            <div className="relative flex sm:hidden flex-col items-center group">
                                                                <div className="border border-blue-normal rounded-xl cursor-pointer bg-white p-2 ml-2">
                                                                    <img className="w-6 h-6" src="../../../../assets/icons/table/filter-eye.png" alt="eye" />
                                                                </div>
                                                                <FilterDataHover filter={filterInputsTwo} />
                                                            </div>
                                                        : null}
                                                        <div ref={dropdownRef3} className="relative"> 
                                                            <div className="sm:hidden flex w-fit items-center cursor-pointer bg-black-300 rounded-lg py-2 px-3 sm:px-4" onClick={(e) => handleShowSort(e, 'two')}>
                                                                <img className="w-6 h-6" src="../../../../assets/icons/table/sort.svg" alt="sort" />
                                                            </div>
                                                            {
                                                                showSortTwo
                                                                ?
                                                                    <ul className="z-20 py-3 bg-white top-14 absolute right-0 border border-white shadow-md rounded-[10px] w-52 text-left h-40 overflow-y-auto no-scrollbar">
                                                                        {sortTypesList.map((value, index) => (
                                                                            <li key={index} onClick={(e) => handleSortTypeTwoDataFromChild((e), value)} className={(sortName === value.name ? "bg-action-hover" : "bg-white") + " hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-xs"}>{ t(value.name)}</li>
                                                                        ))}
                                                                    </ul>
                                                                : null
                                                            }
                                                        </div>
                                                        <div ref={dropdownRef} className="relative">
                                                            <div className="flex w-fit text-right items-center cursor-pointer bg-black-300 rounded-lg py-3 sm:py-2 px-4" onClick={(e) => handleShowFilter(e, 'two')}>
                                                                <img className="w-4" src="../../../../assets/icons/table/filter.svg" alt="filter" />
                                                                <div className="hidden sm:block ml-2 text-blue-normal font-medium text-xl capitalize">{ t('filter')}</div>
                                                            </div>
                                                            {
                                                                showFilterTwo 
                                                                ?
                                                                    <FilterFormLayout>
                                                                        <form onSubmit={(e) => handleFilterSubmit(e, 'two')}>
                                                                            <div className="px-2 sm:px-4 space-y-2 sm:space-y-4">
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('product category')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <button type="button" onClick={(e) => handleShowCategory(e, 'two')} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base py-2 px-3 rounded-md inline-flex items-center">
                                                                                            <span className="text-gray-dark capitalize mr-1 text-xs sm:text-base">{filterInputsTwo.categoryIdArray.length > 0 ? t('filter is applied') : t('select category')}</span>
                                                                                            <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                                        </button>
                                                                                        {
                                                                                            showCategoryTwo
                                                                                            ? 
                                                                                                <ul className="absolute w-full min-h-auto max-h-44 overflow-y-auto no-scrollbar z-30 text-background-dark bg-white shadow-md rounded-md">
                                                                                                    <CategoryCheckbox parentData={filterInputsTwo.categoryIdArray} categoryList={categoryListTwo} sendCategoryDataFromChild={handleCategoryTwoDataFromChild}/>
                                                                                                </ul>                            
                                                                                            : null
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('product group a')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <button type="button" onClick={(e) => handleShowProductGroup(e, 'two')} className="bg-background-normal text-gray-dark w-full justify-between font-normal text-base py-2 px-3 rounded-md inline-flex items-center">
                                                                                            <span className="text-gray-dark capitalize mr-1 text-xs sm:text-base">{filterInputsTwo.productGroupIdArray.length > 0 ? t('filter is applied') : t('select product group')}</span>
                                                                                            <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                                        </button>
                                                                                        {
                                                                                            showProductGroupTwo
                                                                                            ? 
                                                                                                <ul className="absolute w-full min-h-auto max-h-44 overflow-y-auto no-scrollbar z-20 text-background-dark bg-white shadow-md rounded-md">
                                                                                                    <ProductGroupCheckbox parentData={filterInputsTwo.productGroupIdArray} productGroupList={productGroupList} sendProductGroupDataFromChild={handleProductGroupTwoDataFromChild}/>
                                                                                                </ul>                            
                                                                                            : null
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('product code')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <input type="text" name="productCode" value={filterInputsTwo.productCode} onChange={(e) => handleChange(e, "two")} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("product code")} />
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <label className="font-medium capitalize text-sm sm:text-base">{ t('description')}</label>
                                                                                    <div className="inline-block relative w-full mt-1">
                                                                                        <textarea type="text" name="description" value={filterInputsTwo.description} onChange={(e) => handleChange(e, "two")} className="border-background-normal focus:outline-none bg-background-normal rounded-lg py-2 px-3 w-full placeholder:capitalize placeholder:text-sm sm:placeholder:text-base" placeholder={ t("description")} >{filterInputsTwo.description}</textarea>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="flex items-center justify-end my-2">
                                                                                    <div>
                                                                                        <button onClick={(e) => clearFilterData(e, "two")} type="button" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg capitalize">{ t('clear')}</button>
                                                                                    </div>
                                                                                    <div className="ml-4">
                                                                                        <button type="submit" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg capitalize">{ t('apply')}</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </form>
                                                                    </FilterFormLayout>
                                                                : null
                                                            }
                                                            
                                                        </div>
                                                        {(filterInputsTwo.productCode.length > 0 || filterInputsTwo.description.length > 0 || filterInputsTwo.categoryNameArray.length > 0 || filterInputsTwo.productGroupNameArray.length > 0) ? 
                                                            <div className="relative hidden sm:flex flex-col items-center group">
                                                                <div className="border border-blue-normal rounded-xl cursor-pointer bg-white p-2 ml-2">
                                                                    <img className="w-6 h-6" src="../../../../assets/icons/table/filter-eye.png" alt="eye" />
                                                                </div>
                                                                <FilterDataHover filter={filterInputsTwo} />
                                                            </div>
                                                        : null}
                                                    </div>
                                                </div>
                                            </div>
                                            {isTableLoader ? <TableLoaderIcon /> : (products.list.length > 0) ?
                                                <>
                                                    <div className="sm:block hidden mt-4 overflow-x-auto shadow-md rounded-lg">
                                                        <table className="w-full text-xs">
                                                            <thead className="text-gray-normal bg-background-normal">
                                                                <tr>
                                                                    <th scope="col" className="font-normal p-4 w-[40%]">
                                                                        <div className="flex">
                                                                            <div className="mr-2 uppercase">
                                                                                { t('product name')}
                                                                            </div>
                                                                            <SortData fieldName={'productname'} setSortDataFromChild={handleSortDataFromChild} />
                                                                        </div>
                                                                    </th>
                                                                    <th scope="col" className="font-normal p-4">
                                                                        <div className="flex">
                                                                            <div className="mr-2 uppercase">
                                                                                { t('price')}
                                                                            </div>
                                                                            <SortData fieldName={'price'} setSortDataFromChild={handleSortDataFromChild} />
                                                                        </div>
                                                                    </th>
                                                                    <th scope="col" className="font-normal p-4">
                                                                        <div className="flex">
                                                                            <div className="mr-2 uppercase">
                                                                                { t('m/m')}
                                                                            </div>
                                                                            <SortData fieldName={'unit'} setSortDataFromChild={handleSortDataFromChild} />
                                                                        </div>
                                                                    </th>
                                                                    <th scope="col" className="font-normal p-4 text-left uppercase">
                                                                        { t('add item')}
                                                                    </th>
                                                                    <th scope="col" className="font-normal p-4 text-left uppercase">
                                                                        { t('message')}
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                            {products.list.map((row, index) => (
                                                                <tr key={row.productid} className="bg-white border-b hover:bg-gray-50">
                                                                    <td className="py-4 px-2 font-semibold w-[45%]">
                                                                        <div className="flex">
                                                                            <div className="w-14 lg:w-auto">
                                                                                <img className="w-8 h-8" src={row.image ? row.image : defaultProductImage} alt="product-img" />
                                                                            </div>
                                                                            <div className="ml-2 grid justify-between">
                                                                                <h1 className="text-base tracking-wider">{row.b2bline1}</h1>
                                                                                <div className="flex divide-x divide-gray-dark divide-solid items-center">
                                                                                    <div className="text-light-400 capitalize pr-2">{row.b2bline2}</div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td className="py-4 px-2 text-light-400">
                                                                        {formatter.format(row.productprice)} €
                                                                    </td>
                                                                    <td className="py-4 px-2 text-light-400">
                                                                        {row.baseUnitOfMeasure ? row.baseUnitOfMeasure : 'NA'}
                                                                    </td>
                                                                    <td className="py-4 px-2 flex w-52 sm:flex-col sm:items-center sm:justify-center lg:flex-row">
                                                                        <AddQuantityButton row={row} sendQuantityDataFromChild={handleBundleQuantity} staticQuantityArray={productStaticQuantity[row.item_code] ? productStaticQuantity[row.item_code] : 0} popCheck={false} type={"table"} loading={isBundleLoading}/>
                                                                    </td>
                                                                    <td className="py-4 px-2 text-light-400">
                                                                        <MessageLink row={row} staticMessage={productStaticMessage[row.item_code]} sendLinkDataFromChild={handleLinkDataFromChild}/>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                            </tbody>
                                                        </table>
                                                        <Pagination
                                                            currentPage={rowCurrentPage}
                                                            totalCount={products.total_record}
                                                            pageSize={rowsPerPage}
                                                            perPageCount={products.list.length}
                                                            onPageChange={page => handleCurrentPage(page)}
                                                            onPageSizeChange={row => handlePerPage(row)}
                                                        />
                                                    </div>
                                                    <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3">
                                                        <div className="space-y-3 h-[25rem] overflow-y-auto no-scrollbar">
                                                            {products.list.map((row, index) => (
                                                                <div key={row.productid}>
                                                                    <div className="grid space-y-2">
                                                                        <div className="flex">
                                                                            <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-14 h-14" src={row.image ? row.image : defaultProductImage} alt="product" />
                                                                            <div className="ml-2 flex flex-col justify-between w-full">
                                                                                <div>
                                                                                    <div className="font-medium text-xs">{row.b2bline1}</div>
                                                                                    <div className="text-light-400 text-xs capitalize">{row.b2bline2}</div>
                                                                                </div>
                                                                                
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex justify-between items-center">
                                                                            <div>
                                                                            <div className="text-light-400 text-sm text-right">
                                                                                <span className="font-medium">{formatter.format(row.productprice)} €</span>
                                                                            </div>
                                                                            <div className="text-light-400 text-xs flex">
                                                                                <div className="uppercase">{ t('m/m')} : </div><div className="font-medium">{row.baseUnitOfMeasure}</div>
                                                                            </div>
                                                                            </div>
                                                                            <div className="flex">
                                                                                <AddQuantityButton row={row} sendQuantityDataFromChild={handleBundleQuantity} staticQuantityArray={productStaticQuantity[row.item_code] ? productStaticQuantity[row.item_code] : 0} popCheck={false} type={"table"} loading={isBundleLoading}/>
                                                                            </div>
                                                                        </div>
                                                                        <MessageLink row={row} staticMessage={productStaticMessage[row.item_code]} sendLinkDataFromChild={handleLinkDataFromChild}/>
                                                                    </div>
                                                                    <div className="my-3 border-t-2 border-background-normal"></div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <MobilePagination
                                                            currentPage={rowCurrentPage}
                                                            totalCount={products.total_record}
                                                            pageSize={rowsPerPage}
                                                            perPageCount={products.list.length}
                                                            onPageChange={page => handleCurrentPage(page)}
                                                            onPageSizeChange={row => handlePerPage(row)}
                                                        />
                                                    </div>
                                                </>
                                                :
                                                <div className="p-2 sm:p-4 h-36 capitalize bg-white border border-white text-base sm:text-xl rounded-lg flex flex-col justify-center items-center font-semibold">
                                                    { t('no records available')}
                                                </div>
                                            }
                                            <div className="flex justify-between sm:justify-end sm:space-x-2">
                                                <div>
                                                    <button type="button" onClick={(inputs.items.length > 0) ? (e) => openTab(e, 'cart') : null} className={((inputs.items.length > 0) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                        { t('cart')}
                                                    </button>
                                                </div>
                                                <div>
                                                    <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                        { t('summary')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    { showTab === 'cart'
                                        ? 
                                            <div className="space-y-2 relative">
                                                {isCartLoader &&
                                                    <div className="absolute w-full h-full bg-blue-100 z-40 opacity-50">
                                                        <CartLoaderIcon /> 
                                                    </div>
                                                }
                                                <div className="py-2 sm:py-4 bg-white border border-white rounded-lg">
                                                    {/* heading */}
                                                    <div className="px-2 sm:px-4 lg:flex lg:justify-between items-center">
                                                        <div>
                                                            <h1 className="sm:text-xl font-bold capitalize">{ t('items added')}</h1>
                                                        </div>
                                                        <div className="hidden sm:block mt-2 sm:mt-0 sm:pt-0 text-sm text-light-400 capitalize">
                                                            <div className="grid grid-cols-2 gap-2 sm:gap-0 text-[11px] sm:flex sm:divide-x-2 sm:divide-gray-dark sm:divide-solid sm:justify-end sm:items-center"> 
                                                                <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                                                    <h1 className="capitalize font-semibold">{ t('no. of items')}:</h1>
                                                                    <div className="font-bold ml-1">{virtualCartItems.itemsCount}</div>
                                                                </div>
                                                                <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                                                    <h1 className="capitalize font-semibold">{ t('total quantity')}:</h1>
                                                                    <div className="font-bold ml-1">{virtualCartItems.totalQuantity ? formatter.format(virtualCartItems.totalQuantity) : formatter.format(0)}</div>
                                                                </div>
                                                                <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                                                    <h1 className="capitalize font-semibold">{ t('disc. value')}:</h1>
                                                                    <div className="font-bold ml-1">{virtualCartItems.discountAmount ? formatter.format(virtualCartItems.discountAmount) : formatter.format(0)} €</div>
                                                                </div>
                                                                <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                                                    <h1 className="capitalize font-semibold">{ t('net amount')}:</h1>
                                                                    <div className="font-bold ml-1">{virtualCartItems.netAmount ? formatter.format(virtualCartItems.netAmount) : formatter.format(0)} €</div>
                                                                </div>
                                                                <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                                                    <h1 className="capitalize font-semibold">{ t('extra taxes')}:</h1>
                                                                    <div className="font-bold ml-1">{virtualCartItems.totalTaxes ? formatter.format(virtualCartItems.totalTaxes) : formatter.format(0)} €</div>
                                                                </div>
                                                                <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                                                    <h1 className="capitalize font-semibold">{ t('total')} <span className="uppercase">{ t('vat')}</span>:</h1>
                                                                    <div className="font-bold ml-1">{virtualCartItems.vats ? formatter.format(virtualCartItems.vats) : formatter.format(0)} €</div>
                                                                </div>
                                                                <div className="flex sm:grid lg:flex sm:px-1 text-light-400 items-center">
                                                                    <h1 className="capitalize font-semibold">{ t('total amount')}:</h1>
                                                                    <div className="font-bold ml-1">{virtualCartItems.finalAmount ? formatter.format(virtualCartItems.finalAmount) : formatter.format(0)} €</div>
                                                                </div>
                                                            </div> 
                                                        </div>
                                                    </div>
                                                    {/* horizontal line */}
                                                    <div className="my-1 sm:my-3 border-t border-background-normal"></div>
                                                    {/* items table*/}
                                                    { inputs.items.length > 0 
                                                        ?
                                                            <>
                                                                <div className="relative overflow-x-auto sm:block hidden">
                                                                    <table className="w-full text-xs">
                                                                        <thead className="text-gray-normal">
                                                                            <tr>
                                                                                <th scope="col" className="font-normal uppercase px-2 py-3 w-[25%] text-left">
                                                                                    { t('product name')}
                                                                                </th>
                                                                                <th scope="col" className="font-normal uppercase px-2 py-3 text-center">
                                                                                    { t('quantity')}
                                                                                </th>
                                                                                <th scope="col" className="font-normal uppercase px-2 py-3 text-center">
                                                                                    { t('initial price')}
                                                                                </th>
                                                                                <th scope="col" className="font-normal uppercase px-2 py-3 text-center w-[8%]">
                                                                                    { t('discount percentage') }
                                                                                </th>
                                                                                <th scope="col" className="font-normal uppercase px-2 py-3 text-center">
                                                                                    { t('discount price') }
                                                                                </th>
                                                                                <th scope="col" className="font-normal uppercase px-2 py-3 text-center">
                                                                                    { t('net amount') }
                                                                                </th>
                                                                                <th scope="col" className="font-normal uppercase px-2 py-3 text-center">
                                                                                    { t('extra taxes') }
                                                                                </th>
                                                                                <th scope="col" className="font-normal uppercase px-2 py-3 text-center w-[8%]">
                                                                                    { t('vat') }
                                                                                </th>
                                                                                <th scope="col" className="font-normal uppercase px-2 py-3 text-center">
                                                                                    { t('total amount')}
                                                                                </th>
                                                                                <th scope="col" className="font-normal uppercase px-2 py-3 text-left">
                                                                                    { t('add') }/{ t('remove') }
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {inputs.filteredItems.map((item, key) => (
                                                                                <React.Fragment key={'items' + item.product.item_code}>
                                                                                    <tr className={(inputs.filteredItems.length !== key+1 ? 'border-b border-dashed' : '') +" bg-white text-[11px]"}>
                                                                                        <td className="px-2 py-3 font-semibold">
                                                                                            <div className="flex space-x-2">
                                                                                                <img className="w-8 h-8" src={item.product.image ? item.product.image : defaultProductImage} alt="product-img" />
                                                                                                <div className="grid justify-between">
                                                                                                    <h1>{item.product.productname}</h1>
                                                                                                    <p className="text-light-400 text-[10px] capitalize">
                                                                                                        {t('product code')}: {item.product.item_code}
                                                                                                    </p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td className="px-2 py-3 text-light-400 text-center">{item.quantity ? formatter.format(item.quantity) : formatter.format(0)}</td>
                                                                                        <td className="px-2 py-3 text-light-400 text-center">{formatter.format(item.product.productprice)} €</td>
                                                                                        <td className="px-2 py-3 text-light-400 text-center">
                                                                                            {item.product.discount} %
                                                                                        </td>
                                                                                        <td className="px-2 py-3 text-light-400 text-center">
                                                                                            {formatter.format(item.product.discount_amount)} €
                                                                                        </td>
                                                                                        <td className="px-2 py-3 text-light-400 text-center">
                                                                                            {item.quantity ? formatter.format(parseFloat((item.product.productprice * item.quantity).toFixed(2))) : formatter.format(0)} €
                                                                                        </td>
                                                                                        <td className="px-2 py-3 text-light-400 text-center">
                                                                                            {item.quantity ? formatter.format(item.product.extra_taxes * item.quantity) : formatter.format(0)} €
                                                                                        </td>
                                                                                        <td className="px-2 py-3 text-light-400 text-center">
                                                                                            {item.quantity ? formatter.format(parseFloat(((item.product.productprice * item.quantity) * (item.product.vat_percentage / 100)).toFixed(2))) : formatter.format(0)} €
                                                                                        </td>
                                                                                        <td className="px-2 py-3 text-light-400 text-center">
                                                                                            {item.quantity ? formatter.format((
                                                                                                parseFloat((item.product.productprice * item.quantity).toFixed(2)) + 
                                                                                                parseFloat(((item.product.productprice * item.quantity) * (item.product.vat_percentage / 100)).toFixed(2))) +
                                                                                                parseFloat((item.product.extra_taxes * item.quantity)) - 
                                                                                                parseFloat((item.product.discount_amount))
                                                                                            ) : formatter.format(0)} €
                                                                                        </td>
                                                                                        <td className="px-2 py-3 w-44 flex sm:flex-col sm:items-center sm:justify-center lg:flex-row">
                                                                                            <RemoveQuantityButton row={item.product} staticQuantityArray={productStaticQuantity[item.product.item_code]} sendQuantityDataFromChild={handleParentRemove} />
                                                                                        </td>
                                                                                    </tr>
                                                                                    {item.children && item.children.length > 0 && item.children.map((child, childKey) => (
                                                                                        <tr key={'child' + child.product.item_code} className="border-b border-dashed bg-background-normal">
                                                                                            <td className="px-2 py-3 font-semibold">
                                                                                                <div className="flex space-x-2 pl-3">
                                                                                                    <img className="-mt-8" src="../../assets/icons/table/bundle-arrow.svg" alt="bundle" />
                                                                                                    <img className="w-8 h-8" src={child.product.image ? child.product.image : defaultProductImage} alt="product-img" />
                                                                                                    <div className="grid justify-between">
                                                                                                        <h1>{child.product.productname}</h1>
                                                                                                        <p className="text-light-400 text-[10px] capitalize">
                                                                                                            {t('product code')}: {child.product.item_code}
                                                                                                        </p>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td className="px-2 py-3 text-light-400 text-center">{child.quantity ? formatter.format(child.quantity) : formatter.format(0)}</td>
                                                                                            <td className="px-2 py-3 text-light-400 text-center">{formatter.format(child.product.productprice)} €</td>
                                                                                            <td className="px-2 py-3 text-light-400 text-center">
                                                                                                {child.product.discount} %
                                                                                            </td>
                                                                                            <td className="px-2 py-3 text-light-400 text-center">
                                                                                                {formatter.format(child.product.discount_amount)} €
                                                                                            </td>
                                                                                            <td className="px-2 py-3 text-light-400 text-center">
                                                                                                {child.quantity ? formatter.format(parseFloat((child.product.productprice * child.quantity).toFixed(2))) : formatter.format(0)} €
                                                                                            </td>
                                                                                            <td className="px-2 py-3 text-light-400 text-center">
                                                                                                {child.quantity ? formatter.format(child.product.extra_taxes * child.quantity) : formatter.format(0)} €
                                                                                            </td>
                                                                                            <td className="px-2 py-3 text-light-400 text-center">
                                                                                                {child.quantity ? formatter.format(parseFloat(((child.product.productprice * child.quantity) * (child.product.vat_percentage / 100)).toFixed(2))) : formatter.format(0)} €
                                                                                            </td>
                                                                                            <td className="px-2 py-3 text-light-400 text-center">
                                                                                                {child.quantity ? formatter.format((
                                                                                                    parseFloat((child.product.productprice * child.quantity).toFixed(2)) + 
                                                                                                    parseFloat(((child.product.productprice * child.quantity) * (child.product.vat_percentage / 100)).toFixed(2))) +
                                                                                                    parseFloat((child.product.extra_taxes * child.quantity)) -  
                                                                                                    parseFloat((child.product.discount_amount))
                                                                                                ) : formatter.format(0)} €
                                                                                            </td>
                                                                                            <td className="px-2 py-3 w-44 flex sm:flex-col sm:items-center sm:justify-between lg:flex-row">
                                                                                                <div className="w-full py-3 px-1 text-center">
                                                                                                    --
                                                                                                </div>
                                                                                                <button className="capitalize ml-3 sm:mt-2 lg:mt-0"></button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </React.Fragment>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3 p-2 sm:p-4">
                                                                    {(inputs.filteredItems.length > 0) ?
                                                                        <div className="space-y-3">
                                                                            {inputs.filteredItems.map((item, key) => (
                                                                                <div key={'items' + item.product.item_code}>
                                                                                    <div className="grid space-y-2 bg-white border border-gray-200 rounded-lg p-3">
                                                                                        <div className="flex">
                                                                                            <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16" src={item.product.image ? item.product.image : defaultProductImage} alt="product" />
                                                                                            <div className="ml-3 flex flex-col justify-between w-full">
                                                                                                <div>
                                                                                                    <div className="font-medium text-xs">{item.product.productname}</div>
                                                                                                    <div className="text-light-400 text-[10px] capitalize">{t('product code')}: {item.product.item_code}</div>
                                                                                                </div>
                                                                                                <div className="flex text-[10px] justify-between">
                                                                                                    <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                        <h1 className="capitalize font-medium">{t('quantity')}:</h1>
                                                                                                        <div className="font-bold ml-1 sm:ml-2">{item.quantity ? formatter.format(item.quantity) : formatter.format(0)}</div>
                                                                                                    </div>
                                                                                                    <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                        <h1 className="capitalize font-medium">{t('initial price')}:</h1>
                                                                                                        <div className="font-bold ml-1 sm:ml-2">{formatter.format(item.product.productprice)} €</div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="flex text-[10px] justify-between">
                                                                                                    <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                        <h1 className="capitalize font-medium">{t('discount in')} %:</h1>
                                                                                                        <div className="font-bold ml-1 sm:ml-2">
                                                                                                            {item.product.discount}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                        <h1 className="capitalize font-medium">{t('discount in')} €:</h1>
                                                                                                        <div className="font-bold ml-1 sm:ml-2">
                                                                                                            {formatter.format(item.product.discount_amount)}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="flex text-[10px] justify-between">
                                                                                                    <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                        <h1 className="capitalize font-medium">{t('net amt.')}:</h1>
                                                                                                        <div className="font-bold ml-1 sm:ml-2">{item.quantity ? formatter.format(parseFloat((item.product.productprice * item.quantity).toFixed(2))) : formatter.format(0)} €</div>
                                                                                                    </div>
                                                                                                    <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                        <h1 className="uppercase font-medium">{t('vat')}:</h1>
                                                                                                        <div className="font-bold ml-1 sm:ml-2">{item.quantity ? formatter.format(parseFloat(((item.product.productprice * item.quantity) * (item.product.vat_percentage / 100)).toFixed(2))) : formatter.format(0)} €</div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="flex text-[10px] justify-between">
                                                                                                    <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                        <h1 className="capitalize font-medium">{t('extra taxes')}:</h1>
                                                                                                        <div className="font-bold ml-1 sm:ml-2">{item.quantity ? formatter.format(item.product.extra_taxes * item.quantity) : formatter.format(0)} €</div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="flex justify-between items-center">
                                                                                            <div>
                                                                                                <div className="capitalize text-xs font-medium">{t('total amount')}:</div>
                                                                                                <div className="font-bold text-sm">
                                                                                                    <div>
                                                                                                        {item.quantity ? formatter.format((
                                                                                                            parseFloat((item.product.productprice * item.quantity).toFixed(2)) + 
                                                                                                            parseFloat(((item.product.productprice * item.quantity) * (item.product.vat_percentage / 100)).toFixed(2))) +
                                                                                                            parseFloat((item.product.extra_taxes * item.quantity)) - 
                                                                                                            parseFloat((item.product.discount_amount))
                                                                                                        ) : formatter.format(0)} €
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="flex">
                                                                                                <RemoveQuantityButton row={item.product} staticQuantityArray={productStaticQuantity[item.product.item_code]} sendQuantityDataFromChild={handleParentRemove} />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    {item.children && item.children.length > 0 && (
                                                                                        <div className="mt-2 space-y-2">
                                                                                            {item.children.map((child, childKey) => (
                                                                                                <div key={'child' + child.product.item_code} className="grid space-y-2 bg-gray-100 border border-gray-200 rounded-lg p-3">
                                                                                                    <div className="flex">
                                                                                                        <img src="../../assets/icons/table/bundle-arrow.svg" className="w-4 h-4 mt-2 mr-2" alt="bundle" />
                                                                                                        <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-10 h-10" 
                                                                                                            src={child.product.image ? child.product.image : defaultProductImage} 
                                                                                                            alt="product" />
                                                                                                        <div className="ml-2 flex flex-col justify-between w-full">
                                                                                                            <div>
                                                                                                                <div className="font-medium text-xs">{child.product.productname}</div>
                                                                                                                <div className="text-light-400 text-[10px] capitalize">{t('product code')}: {child.product.item_code}</div>
                                                                                                            </div>
                                                                                                            <div className="flex text-[10px] justify-between">
                                                                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                                    <h1 className="capitalize font-medium">{t('quantity')}:</h1>
                                                                                                                    <div className="font-bold ml-1 sm:ml-2">{child.quantity ? formatter.format(child.quantity) : formatter.format(0)}</div>
                                                                                                                </div>
                                                                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                                    <h1 className="capitalize font-medium">{t('initial price')}:</h1>
                                                                                                                    <div className="font-bold ml-1 sm:ml-2">{formatter.format(child.product.productprice)} €</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="flex text-[10px] justify-between">
                                                                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                                    <h1 className="capitalize font-medium">{t('discount in')} %:</h1>
                                                                                                                    <div className="font-bold ml-1 sm:ml-2">
                                                                                                                        {child.product.discount}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                                    <h1 className="capitalize font-medium">{t('discount in')} €:</h1>
                                                                                                                    <div className="font-bold ml-1 sm:ml-2">
                                                                                                                        {formatter.format(child.product.discount_amount)}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="flex text-[10px] justify-between">
                                                                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                                    <h1 className="capitalize font-medium">{t('net amt.')}:</h1>
                                                                                                                    <div className="font-bold ml-1 sm:ml-2">{child.quantity ? formatter.format(parseFloat((child.product.productprice * child.quantity).toFixed(2))) : formatter.format(0)} €</div>
                                                                                                                </div>
                                                                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                                    <h1 className="uppercase font-medium">{t('vat')}:</h1>
                                                                                                                    <div className="font-bold ml-1 sm:ml-2">{child.quantity ? formatter.format(parseFloat(((child.product.productprice * child.quantity) * (child.product.vat_percentage / 100)).toFixed(2))) : formatter.format(0)} €</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="flex text-[10px] justify-between">
                                                                                                                <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                                    <h1 className="capitalize font-medium">{t('extra taxes')}:</h1>
                                                                                                                    <div className="font-bold ml-1 sm:ml-2">{child.quantity ? formatter.format(child.product.extra_taxes * child.quantity) : formatter.format(0)} €</div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <div className="flex justify-between items-center">
                                                                                                        <div>
                                                                                                            <div className="capitalize text-xs font-medium">{t('total amount')}:</div>
                                                                                                            <div className="font-bold text-sm">
                                                                                                                <div>
                                                                                                                    {child.quantity ? formatter.format((
                                                                                                                        parseFloat((child.product.productprice * child.quantity).toFixed(2)) + 
                                                                                                                        parseFloat(((child.product.productprice * child.quantity) * (child.product.vat_percentage / 100)).toFixed(2))) +
                                                                                                                        parseFloat((child.product.extra_taxes * child.quantity)) -  
                                                                                                                        parseFloat((child.product.discount_amount))
                                                                                                                    ) : formatter.format(0)} €
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    )}
                                                                                    <div className="my-3 border-t-2 border-background-normal"></div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                        : null
                                                                    }
                                                                </div>
                                                            </>
                                                        : 
                                                        <div className="p-2 sm:p-4 h-36 capitalize bg-white border border-white text-base sm:text-xl rounded-lg flex flex-col justify-center items-center font-semibold">
                                                            { t('not added yet')}
                                                        </div>
                                                    }
                                                </div>
                                                { isCalculate
                                                    ?
                                                        <div className="p-2 sm:p-4 bg-white border border-white rounded-lg grid lg:grid-cols-2 xl:grid-cols-3 space-y-2 xl:space-y-0">
                                                            <label className="block sm:hidden font-semibold text-sm capitalize">{ t('coupon code') }:</label>
                                                            <div className="flex w-full justify-between sm:justify-normal items-center sm:space-x-3 xl:col-span-2 text-sm sm:text-base">
                                                                <label className="hidden sm:block font-semibold capitalize">{ t('coupon code') }:</label>
                                                                <input type="text" name="couponCode" value={inputs.couponCode} onChange={(e) => handleCouponCodeChange(e)} className="border-background-normal focus:outline-none bg-background-normal rounded-md p-2 placeholder:capitalize" placeholder={ t("coupon code")} />
                                                                <button type="button" onClick={(e) => handleApplyCouponCode(e)} className="capitalize font-semibold bg-black-300 text-blue-normal py-2 px-2 sm:px-4 rounded-lg">{ t('apply')}</button>
                                                            </div>
                                                            <div className="flex justify-between lg:justify-end lg:space-x-2 items-center">
                                                                <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                                    { t('summary')}
                                                                </button>
                                                                {!showCalculating 
                                                                    ?
                                                                    <button type="button" onClick={(e) => calculateItemsAmount(e)} className=" cursor-pointer bg-blue-normal border-blue-normal capitalize text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white border rounded-lg tracking-wide w-fit">{!reCalculate ? t('calculate final amount') : t('re-calculate final amount')}</button>
                                                                    :
                                                                    <button type="button" className="cursor-wait bg-blue-normal border-blue-normal capitalize text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white border rounded-lg tracking-wide w-fit">{ t('calculating') }...</button>
                                                                }
                                                            </div>
                                                        </div>
                                                    : 
                                                        <div className="text-right">
                                                            <button type="button" onClick={((Object.keys(validateValues(inputs)).length === 0 && calculateButton)) ? (e) => openTab(e, 'summary') : null} className={((Object.keys(validateValues(inputs)).length === 0 && calculateButton) ? "bg-blue-normal border-blue-normal cursor-pointer" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " w-24 text-white p-2 border  rounded-lg text-center capitalize font-semibold text-sm sm:text-base"}>
                                                                { t('summary')}
                                                            </button>
                                                        </div>
                                                }
                                                { (inputs.items.length > 0 && isCalculate) 
                                                    ? 
                                                        <div className="space-y-2">
                                                            { filterCalculateItems.length > 0 
                                                                ?
                                                                    <div className="bg-white border border-white rounded-lg">
                                                                        <div className="p-2 sm:p-4 lg:flex lg:justify-between items-center">
                                                                            <div>
                                                                                <h1 className="lg:text-xl font-bold capitalize">{ t('calculated items')}</h1>
                                                                            </div>
                                                                            <div className="mt-2 sm:pt-0 text-sm text-light-400 capitalize">
                                                                                <div className="grid grid-cols-2 gap-2 text-xs sm:flex sm:divide-x-2 sm:divide-gray-dark sm:divide-solid sm:justify-end sm:items-center"> 
                                                                                    <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                                                                        <h1 className="capitalize font-semibold">{ t('no. of items')}:</h1>
                                                                                        <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{calculateCartItems.itemsCount}</div>
                                                                                    </div>
                                                                                    <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                                                                        <h1 className="capitalize font-semibold">{ t('total quantity')}:</h1>
                                                                                        <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{formatter.format(calculateCartItems.totalQuantity)}</div>
                                                                                    </div>
                                                                                    <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                                                                        <h1 className="capitalize font-semibold">{ t('net amount')}:</h1>
                                                                                        <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{formatter.format(calculateCartItems.netAmount)} €</div>
                                                                                    </div>
                                                                                    <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                                                                        <h1 className="capitalize font-semibold">{ t('total')} <span className="uppercase">{ t('vat')}</span>:</h1>
                                                                                        <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{formatter.format(calculateCartItems.vats)} €</div>
                                                                                    </div>
                                                                                    <div className="flex sm:grid lg:flex sm:px-3 text-light-400 items-center">
                                                                                        <h1 className="capitalize font-semibold">{ t('total amount')}:</h1>
                                                                                        <div className="font-bold ml-1 sm:ml-0 lg:ml-2">{formatter.format(calculateCartItems.totalAmount)} €</div>
                                                                                    </div>
                                                                                </div> 
                                                                            </div>
                                                                        </div>
                                                                        <div className="my-3 border-t border-background-normal"></div>
                                                                        <div className="relative overflow-x-auto sm:block hidden">
                                                                            <table className="w-full text-xs">
                                                                                <thead className="text-gray-normal">
                                                                                    <tr>
                                                                                        <th scope="col" className="font-normal p-3 ">
                                                                                            <div className="flex">
                                                                                                <div className="mr-2 uppercase">
                                                                                                    { t('product name')}
                                                                                                </div>
                                                                                                <SortItem fieldName={'item_code1'} rows={calculatedItems} setFilteredDataFromChild={handleFilterItemsSortDataFromChild} />
                                                                                            </div>
                                                                                        </th>
                                                                                        <th scope="col" className="font-normal p-3 ">
                                                                                            <div className="flex">
                                                                                                <div className="mr-2 uppercase">
                                                                                                    { t('initial price')}
                                                                                                </div>
                                                                                                <SortItem fieldName={'productprice1'} rows={calculatedItems} setFilteredDataFromChild={handleFilterItemsSortDataFromChild} />
                                                                                            </div>
                                                                                        </th>
                                                                                        <th scope="col" className="font-normal p-3 ">
                                                                                            <div className="flex">
                                                                                                <div className="mr-2 uppercase">
                                                                                                    { t('quantity')}
                                                                                                </div>
                                                                                                <SortItem fieldName={'quantity1'} rows={calculatedItems} setFilteredDataFromChild={handleFilterItemsSortDataFromChild} />
                                                                                            </div>
                                                                                        </th>
                                                                                        <th scope="col" className="font-normal p-3 ">
                                                                                            <div className="flex">
                                                                                                <div className="mr-2 uppercase">
                                                                                                    { t('net amount') }
                                                                                                </div>
                                                                                                <SortItem fieldName={'netvalue1'} rows={calculatedItems} setFilteredDataFromChild={handleFilterItemsSortDataFromChild} />
                                                                                            </div>
                                                                                        </th>
                                                                                        <th scope="col" className="font-normal p-3 ">
                                                                                            <div className="flex">
                                                                                                <div className="mr-2 uppercase">
                                                                                                    { t('vat') }
                                                                                                </div>
                                                                                                <SortItem fieldName={'vaT_Value1'} rows={calculatedItems} setFilteredDataFromChild={handleFilterItemsSortDataFromChild} />
                                                                                            </div>
                                                                                        </th>
                                                                                        <th scope="col" className="font-normal p-3 text-left">
                                                                                            <div className="flex">
                                                                                                <div className="mr-2 uppercase">
                                                                                                    { t('total amount')}
                                                                                                </div>
                                                                                                <SortItem fieldName={'amount1'} rows={calculatedItems} setFilteredDataFromChild={handleFilterItemsSortDataFromChild} />
                                                                                            </div>
                                                                                        </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {filterCalculateItems.map((value, key) => (
                                                                                        <tr key={'items'+key} className={(filterCalculateItems.length !== key+1 ? 'border-b border-dashed' : '') +" bg-white hover:bg-gray-50"}>
                                                                                            <td className="p-3 font-semibold">
                                                                                                <div className="flex">
                                                                                                    <div className="w-14 xl:w-auto">
                                                                                                        <img className="w-8 h-8" src={value.image ? value.image : defaultProductImage} alt="product-img" />
                                                                                                    </div>
                                                                                                    <div className="ml-2 grid justify-between">
                                                                                                        <h1>{value.product_name}</h1>
                                                                                                        <p className="text-light-400 text-[10px] capitalize">{ t('product code')}: {value.item_code}</p>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td className="p-3 text-light-400">
                                                                                                {formatter.format(value.UnitPrice)} €
                                                                                            </td>
                                                                                            <td className="p-3 text-light-400">
                                                                                                {formatter.format(value.QTY1)}
                                                                                            </td>
                                                                                            <td className="p-3 text-light-400">
                                                                                                {formatter.format( parseFloat( (value.UnitPrice * value.QTY1).toFixed(2) ) )} €
                                                                                            </td>
                                                                                            <td className="p-3 text-light-400">
                                                                                                {formatter.format( parseFloat( ((value.UnitPrice * value.QTY1) * (value.vat_percent / 100)).toFixed(2) ) )} €
                                                                                            </td>
                                                                                            <td className="p-3 text-light-400">
                                                                                                {formatter.format( parseFloat( (value.UnitPrice * value.QTY1).toFixed(2) ) + parseFloat( ((value.UnitPrice * value.QTY1) * (value.vat_percent/100)).toFixed(2) ) )} €
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                        <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3 p-2 sm:p-4">
                                                                            {(filterCalculateItems.length > 0) ?
                                                                                <div className="space-y-3">
                                                                                    { filterCalculateItems.map((value, key) => (
                                                                                        <div key={'value'+key}>
                                                                                            <div className="grid space-y-2">
                                                                                                <div className="flex">
                                                                                                    <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-16 h-16" src={value.image ? value.image : defaultProductImage} alt="product" />
                                                                                                    <div className="ml-1 flex flex-col justify-between w-full space-y-1">
                                                                                                        <div>
                                                                                                            <div className="font-medium text-xs">{value.productname}</div>
                                                                                                            <div className="text-light-400 text-[10px] capitalize">{ t('product code')}: {value.item_code}</div>
                                                                                                        </div>
                                                                                                        <div className="flex text-xs justify-between">
                                                                                                            <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                                <h1 className="capitalize font-medium">{ t('initial price')}:</h1>
                                                                                                                <div className="font-bold ml-1 sm:ml-2">{formatter.format(value.UnitPrice)} €</div>
                                                                                                            </div>
                                                                                                            <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                                <h1 className="capitalize font-medium">{ t('quantity')}:</h1>
                                                                                                                <div className="font-bold ml-1 sm:ml-2">{formatter.format(value.QTY1)}</div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                        <div className="flex text-xs justify-between">
                                                                                                            <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                                <h1 className="capitalize font-medium">{ t('net amount')}:</h1>
                                                                                                                <div className="font-bold ml-1 sm:ml-2">{formatter.format( parseFloat( (value.UnitPrice * value.QTY1).toFixed(2) ) )} €</div>
                                                                                                            </div>
                                                                                                            <div className="flex sm:px-3 text-light-400 items-center">
                                                                                                                <h1 className="uppercase font-medium">{ t('vat')} :</h1>
                                                                                                                <div className="font-bold ml-1 sm:ml-2">{formatter.format( parseFloat( ((value.UnitPrice * value.QTY1) * (value.vat_percent / 100)).toFixed(2) ) )} €</div>
                                                                                                            </div>
                                                                                                        </div> 
                                                                                                        <div className="text-right">
                                                                                                            <span className="capitalize font-medium text-xs">{ t('total amount')} : </span>
                                                                                                            <span className="font-bold text-sm">
                                                                                                                {formatter.format( parseFloat( (value.UnitPrice * value.QTY1).toFixed(2) ) + parseFloat( ((value.UnitPrice * value.QTY1) * (value.vat_percent/100)).toFixed(2) ) )} €
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="my-3 border-t-2 border-background-normal"></div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                                : null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                : 
                                                                    null
                                                            }
                                                        </div>
                                                    : null 
                                                }
                                                
                                            </div>
                                        : null
                                    }
                                    { showTab === 'summary'
                                        ? 
                                            <div className="space-y-2">
                                                <div className="md:grid md:grid-cols-6 space-y-2 md:space-y-0 md:gap-2 p-2 sm:p-4 bg-white border border-white rounded-lg md:divide-x-2 md:divide-gray-dark md:divide-dashed">
                                                    <div className="space-y-1 md:space-y-2">
                                                        <div className=" font-semibold capitalize text-sm">{ t('payment method')}:</div>
                                                        <div ref={dropdownRef1} className="w-auto relative">
                                                            <div onClick={(e) => openPaymentMethod(e)}>
                                                                <button className="bg-background-normal justify-between font-normal text-base px-3 py-3 rounded-md inline-flex items-center w-full">
                                                                    <span className={((paymentMethod && paymentMethod.length > 0) ? "text-black" : "text-gray-dark") + " mr-6 text-xs sm:text-sm"}>{(paymentMethod && paymentMethod.length > 0) ? paymentMethod : t('select payment method')}</span>
                                                                    <img src="../../../../assets/icons/select-down.svg" alt="select-down" />
                                                                </button>
                                                            </div>
                                                            {
                                                                showPaymentMethod
                                                                ? 
                                                                    <ul className={(paymentMethods.length > 4 ? "min-h-auto max-h-40" : "" ) + " absolute z-10 text-background-dark bg-white shadow-md rounded-md w-full overflow-y-auto no-scrollbar"}>
                                                                        { paymentMethods.length > 0 ?
                                                                            paymentMethods.map((method, index) => (
                                                                                <li key={index} onClick={(e) => handlePaymentMethod((e), method)} className="bg-white hover:bg-action-hover cursor-pointer py-1.5 px-3 block whitespace-no-wrap capitalize text-xs sm:text-sm">{method.name}</li>
                                                                            ))
                                                                            : null
                                                                        }
                                                                    </ul>                            
                                                                : null
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="md:pl-2 space-y-1 md:space-y-2">
                                                        <div className=" font-semibold capitalize text-sm">{ t('delivery date')}:</div>
                                                        <DateInputField className="text-sm" setDataFromChild={handleDateDataFromChild} startDate={currentDate} dateInput={deliveryDate} disableDate={true} week={disbaleWeeks}/>
                                                    </div>
                                                    {isCompanyChecked &&
                                                        <div className="col-span-2 md:pl-2 space-y-1 md:space-y-2">
                                                            <div className="flex justify-between items-center">
                                                                <div className=" font-semibold capitalize text-sm">{t('transportation company')}:</div>
                                                                <button onClick={(e) => setShowTransportationFormModal(!showTransportationFormModal)} type="button" className="cursor-pointer  flex items-center space-x-2 text-blue-normal text-sm font-medium">
                                                                    + <div className="capitalize">{ t('add new')}</div>
                                                                </button>
                                                            </div>
                                                            <TransportationDropdown transportationList={transportationList} transportationCompanyName={transportationCompanyName} sendTransportationChildData={handleTransportationCompany} />
                                                        </div>
                                                    }
                                                    {isAddressChecked &&
                                                        <div className="col-span-2 md:pl-2 space-y-1 md:space-y-2">
                                                            <div className="flex justify-between items-center">
                                                                <div className=" font-semibold capitalize text-sm">{t('customer delivery address')}:</div>
                                                                <button onClick={(e) => setShowDeliveryFormModal(!showDeliveryFormModal)} type="button" className="cursor-pointer  flex items-center space-x-2 text-blue-normal text-sm font-medium">
                                                                    + <div className="capitalize">{ t('add new')}</div>
                                                                </button>
                                                            </div>
                                                            <DeliveryAddressDropdown deliveryAddressList={deliveryAddressList} personName={personName} sendTransportationChildData={handleDeliveryAddress} />
                                                        </div>
                                                    }
                                                </div>
                                                
                                                <div className="grid sm:grid-cols-2 gap-2 sm:space-x-2">
                                                    <div className="p-2 sm:p-4 bg-white border border-white rounded-lg text-xs sm:text-base h-fit">
                                                        <div className="space-y-2">
                                                            <div className="font-semibold capitalize w-fit">{ t('comments')}</div>
                                                            <textarea name="comment" rows="7" columns="10" value={comment} onChange={(e) => handleCommentChange(e)} className="w-full border-background-normal focus:outline-none bg-background-normal rounded-lg p-2 placeholder:capitalize" placeholder={ t("write comments here...")} >{comment}</textarea>
                                                        </div>
                                                    </div>
                                                    {/* <div className="sm:space-y-2">
                                                        <div className="py-2 sm:py-4 bg-white border border-white rounded-lg">
                                                            <div className="px-2 sm:px-4">
                                                                <h1 className="sm:text-lg font-semibold capitalize">{ t('items summary')}</h1>
                                                            </div>
                                                            <div className="my-3 border-t border-background-normal"></div>
                                                            <div className="px-2 sm:px-4 text-right space-y-2">
                                                                <div className="flex justify-between items-center">
                                                                    <div className="text-light-400 text-sm font-normal capitalize">{ t('no. of items')}</div>
                                                                    <div className="font-bold text-sm">{virtualCartItems.itemsCount}</div>
                                                                </div>
                                                                <div className="flex justify-between items-center">
                                                                    <div className="text-light-400 text-sm font-normal capitalize">{ t('total quantity')}</div>
                                                                    <div className="font-bold text-sm">{virtualCartItems.totalQuantity ? formatter.format(virtualCartItems.totalQuantity) : formatter.format(0)}</div>
                                                                </div>
                                                                <div className="flex justify-between items-center">
                                                                    <div className="text-light-400 text-sm font-normal capitalize">{ t('net amount')}</div>
                                                                    <div className="font-bold text-sm">{virtualCartItems.netAmount ? formatter.format(virtualCartItems.netAmount) : formatter.format(0)} €</div>
                                                                </div>
                                                                <div className="flex justify-between items-center">
                                                                    <div className="text-light-400 text-sm font-normal uppercase">{ t('vat')}</div>
                                                                    <div className="font-bold text-sm">{virtualCartItems.vats ? formatter.format(virtualCartItems.vats) : formatter.format(0)} €</div>
                                                                </div>
                                                                <div className="my-3 border-t border-background-normal"></div>
                                                                <div className="flex justify-between items-center">
                                                                    <div className="font-semibold capitalize">{ t('total amount')}</div>
                                                                    <div className="font-bold text-sm">{virtualCartItems.totalAmount ? formatter.format(virtualCartItems.totalAmount) : formatter.format(0)} €</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        { filterCalculateItems.length > 0 ?
                                                            <div className="py-2 sm:py-4 bg-white border border-white rounded-lg">
                                                                <div className="px-2 sm:px-4">
                                                                    <h1 className="sm:text-lg font-semibold capitalize">{ t('calculated items summary')}</h1>
                                                                </div>
                                                                <div className="my-3 border-t border-background-normal"></div>
                                                                <div className="px-2 sm:px-4 text-right space-y-2">
                                                                    <div className="flex justify-between items-center">
                                                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('no. of items')}</div>
                                                                        <div className="font-bold text-sm">{calculateCartItems.itemsCount}</div>
                                                                    </div>
                                                                    <div className="flex justify-between items-center">
                                                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('total quantity')}</div>
                                                                        <div className="font-bold text-sm">{calculateCartItems.totalQuantity ? formatter.format(calculateCartItems.totalQuantity) : formatter.format(0)}</div>
                                                                    </div>
                                                                    <div className="flex justify-between items-center">
                                                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('total net value')}</div>
                                                                        <div className="font-bold text-sm">{calculateCartItems.netAmount ? formatter.format(calculateCartItems.netAmount) : formatter.format(0)} €</div>
                                                                    </div>
                                                                    <div className="flex justify-between items-center">
                                                                        <div className="text-light-400 text-sm font-normal uppercase">{ t('vat')}</div>
                                                                        <div className="font-bold text-sm">{calculateCartItems.vats ? formatter.format(calculateCartItems.vats) : formatter.format(0)} €</div>
                                                                    </div>
                                                                    <div className="flex justify-between items-center">
                                                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('total amo0unt')}</div>
                                                                        <div className="font-bold text-sm">{calculateCartItems.totalAmount ? formatter.format(calculateCartItems.totalAmount) : formatter.format(0)} €</div>
                                                                    </div>
                                                                    <div className="flex justify-between items-center">
                                                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('discount percentage')}</div>
                                                                        <div className="font-bold text-sm">{calculateCartItems.discountPercentage} %</div>
                                                                    </div>
                                                                    <div className="flex justify-between items-center">
                                                                        <div className="text-light-400 text-sm font-normal capitalize">{ t('discount amount')}</div>
                                                                        <div className="font-bold text-sm">{calculateCartItems.discountAmount ? formatter.format(calculateCartItems.discountAmount) : formatter.format(0)} €</div>
                                                                    </div>
                                                                    <div className="my-3 border-t border-background-normal"></div>
                                                                    <div className="flex justify-between items-center">
                                                                        <div className="font-semibold capitalize">{ t('total amount')}</div>
                                                                        <div className="font-bold text-sm">{calculateCartItems.finalAmount ? formatter.format(calculateCartItems.finalAmount) : formatter.format(0)} €</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : null 
                                                        }
                                                    </div> */}
                                                    <div className="py-2 sm:py-4 bg-white border border-white rounded-lg">
                                                        {/* heading */}
                                                        <div className="px-2 sm:px-4">
                                                            <h1 className="sm:text-lg font-semibold capitalize">{ t('final order summary')}</h1>
                                                        </div>
                                                        {/* horizontal line */}
                                                        <div className="my-3 border-t border-background-normal"></div>
                                                        {/* order summary */}
                                                        <div className="px-2 sm:px-4 text-right space-y-3.5">
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('no. of items')}</div>
                                                                <div className="font-bold text-sm">{finalCartItems.itemsCount}</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('total quantity')}</div>
                                                                <div className="font-bold text-sm">{formatter.format(finalCartItems.totalQuantity)}</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('discount value')}</div>
                                                                <div className="font-bold text-sm">{formatter.format(finalCartItems.discountAmount)} €</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('total net value')}</div>
                                                                <div className="font-bold text-sm">{formatter.format(finalCartItems.netAmount)} €</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('extra taxes')}</div>
                                                                <div className="font-bold text-sm">{formatter.format(finalCartItems.totalTaxes)} €</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('total')} <span className="uppercase">{ t('vat')}</span></div>
                                                                <div className="font-bold text-sm">{formatter.format(finalCartItems.vats)} €</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('total amount')}</div>
                                                                <div className="font-bold text-sm">{formatter.format(finalCartItems.finalAmount)} €</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-sm font-normal capitalize">{ t('transportation fee')}</div>
                                                                <div className="font-bold text-sm">{formatter.format(shippingCost)} €</div>
                                                            </div>
                                                            <div className="my-3 border-t border-background-normal"></div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="font-semibold first-letter:capitalize">{ t('amount to be paid')}</div>
                                                                <div className="font-bold text-sm">{formatter.format(finalCartItems.finalAmount + shippingCost)} €</div>
                                                            </div>
                                                            <div className="flex justify-between items-center">
                                                                <div className="text-light-400 text-xs font-normal capitalize">{ t('coupon code')}:</div>
                                                                <div className="font-bold text-xs">{inputs.couponCode ? inputs.couponCode : '--'}</div>
                                                            </div>
                                                            <form onSubmit={handleSubmit} autoComplete="off">
                                                                { !formButton 
                                                                    ?
                                                                        <button type={(Object.keys(validateValues(inputs)).length === 0 && deliveryDate.length > 0 && paymentMethod && calculateButton) ? "submit" : "button"} className={((Object.keys(validateValues(inputs)).length === 0 && deliveryDate.length > 0 && paymentMethod && calculateButton)? "cursor-pointer bg-blue-normal border-blue-normal" : "cursor-not-allowed bg-blue-disable border-blue-disable") + " text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white border rounded-lg tracking-wide capitalize"}>{ t('finalization')}</button>
                                                                    :
                                                                        <button type="button" className="cursor-wait bg-blue-normal border-blue-normal capitalize text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white border rounded-lg tracking-wide ">{ t('Please wait, in-progress') }</button>
                                                                }
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        : null
                                    }
                                </div>
                            </div>
                    }
                </div>
            </Layout>
            {(showBundleModal) && 
                <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 h-full">
                    <div className="flex items-center justify-center min-height-100vh text-center sm:block sm:p-0 h-full">
                        <div className="fixed inset-0 transition-opacity">
                            <div className="absolute inset-0 bg-gray-900 opacity-75" />
                        </div>
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                        <div className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-[36rem] w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                            <div className="bg-white py-4 px-4 space-y-3">
                                <div className="flex justify-between space-x-4 sm:space-x-0">
                                    <div className="font-semibold text-sm sm:text-lg capitalize">{ t('add relative products')}</div>
                                    <div className="cursor-pointer" onClick={(e) => setShowBundleModal(!showBundleModal)}>
                                        <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                                    </div>
                                </div>
                                <div>
                                    <div className="space-y-2">
                                        <div className="hidden sm:block">
                                            <table className="w-full text-xs">
                                                <thead className="text-gray-normal border-b border-dashed">
                                                    <tr>
                                                        <th scope="col" className="font-normal p-2 text-left uppercase w-[40%]">
                                                            { t('product name')}
                                                        </th>
                                                        <th scope="col" className="font-normal p-2 text-left uppercase w-[15%]">
                                                            { t('price')}
                                                        </th>
                                                        <th scope="col" className="font-normal p-2 text-left uppercase w-[15%]">
                                                            { t('m/m')}
                                                        </th>
                                                        <th scope="col" className="font-normal p-2 text-left uppercase w-[15%]">
                                                            { t('qty')}
                                                        </th>
                                                        <th scope="col" className="font-normal p-2 text-center uppercase w-[15%]">
                                                            { t('add item')}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bundleProducts.map((value, key) => (
                                                        <tr key={'items'+key} className={"border-b border-dashed bg-white"}>
                                                            <td className="p-2 font-semibold">
                                                                <div className="flex">
                                                                    <img className="w-8 h-8" src={value.product.image ? value.product.image : defaultProductImage} alt="product-img" />
                                                                    <div className="ml-2 grid justify-between">
                                                                        <h1 className="text-xs font-medium">{value.product.b2bline1}</h1>
                                                                        <p className="text-light-400 text-[10px] capitalize">{value.product.b2bline2}</p>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="p-2 text-light-400">
                                                                {formatter.format(value.product.productprice)} €
                                                            </td>
                                                            <td className="p-2 text-light-400">
                                                                {value.product.baseUnitOfMeasure}
                                                            </td>
                                                            <td className="p-2 text-light-400">
                                                                {formatter.format(value.quantity)}
                                                            </td>
                                                            <td>
                                                                <label className="relative flex flex-col justify-center items-center cursor-pointer">
                                                                    <input type="checkbox" name={`bundleProduct-${value.product.productid}`} checked={selectedItems.some(item => item.id === value.product.productid)} onChange={(e) => handleSelectedBundle(e, value)} className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded-full border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                                    <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                                        </svg>
                                                                    </span>
                                                                </label>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="block sm:hidden space-y-2">
                                            <div className="flex justify-between w-full">
                                                <div className="w-[75%]">
                                                    <h1 className="text-xs uppercase text-gray-normal">product</h1>
                                                </div>
                                                <div className="[w-25%]">
                                                    <h1 className="text-xs uppercase text-gray-normal">add items</h1>
                                                </div>
                                            </div>
                                            {bundleProducts.map((value, key) => (
                                                <div key={'value1'+key}>
                                                    <div className="flex justify-between items-center w-full">
                                                        <div className="w-[75%]">
                                                            <div className="flex">
                                                                <img className="border border-black-100 bg-black-100 rounded-lg flex flex-col justify-center items-center w-12 h-12" src={value.product.image ? value.product.image : defaultProductImage} alt="product" />
                                                                <div className="ml-1 flex flex-col justify-between w-full space-y-1">
                                                                    <div className="font-medium text-xs">{value.product.b2bline1}</div>
                                                                    <div className="flex items-center space-x-2">
                                                                        <div className="text-light-400 text-[10px] capitalize">{value.product.b2bline2}</div>
                                                                        
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="[w-25%]">
                                                            <div className="">
                                                                <label className="relative flex flex-col justify-center items-center cursor-pointer">
                                                                    <input type="checkbox" name={`bundleProduct-${value.product.productid}`} checked={selectedItems.some(item => item.id === value.product.productid)} onChange={(e) => handleSelectedBundle(e, value)} className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded-full border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-6 before:w-6 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                                    <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                                        </svg>
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="mt-2 flex text-xs justify-between">
                                                        <div className="flex sm:px-3 text-light-400 items-center">
                                                            <h1 className="capitalize font-medium">{ t('price')}:</h1>
                                                            <div className="font-bold ml-1">{formatter.format(value.product.productprice)} €</div>
                                                        </div>
                                                        <div className="flex sm:px-3 text-light-400 items-center">
                                                            <h1 className="capitalize font-medium">{ t('qty')}:</h1>
                                                            <div className="font-bold ml-1">{formatter.format(value.quantity)}</div>
                                                        </div>
                                                        <div className="flex sm:px-3 text-light-400 items-center">
                                                            <h1 className="capitalize font-medium">{ t('m/m')}:</h1>
                                                            <div className="font-bold ml-1">{value.product.baseUnitOfMeasure}</div>
                                                        </div>
                                                    </div>
                                                    {(bundleProducts.length > key+1) && <div className="my-3 border-t-2 border-background-normal"></div>}
                                                </div>
                                            ))}
                                        </div>
                                        <div className="flex justify-end pt-2 items-center space-x-2">
                                            <button onClick={(e) => setShowBundleModal(!showBundleModal)} type="button" className="text-center px-4 text-xs font-medium sm:text-base py-2 text-blue-normal bg-white border border-blue-normal rounded-lg tracking-wide first-letter:capitalize">{ t('skip') }</button>
                                            <button onClick={(e) => handleUpdateBundleItems(e)} type="button" className="bg-blue-normal text-white px-4 py-2 text-xs font-medium sm:text-base rounded-lg border border-blue-normal capitalize">
                                                {('add')}
                                            </button>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            }
            {(showDeliveryFormModal) && 
                <CustomerFormModal customerId={customerid} title="add customer delivery address" type="delivery address" setShowCustomerFormModal={setShowDeliveryFormModal} sendInfoFromChild={handleDeliveryInfoFromChild} />
            }
            {(showTransportationFormModal) && 
                <CustomerFormModal customerId={customerid} title="add transportation company address" type="transportation company" setShowCustomerFormModal={setShowTransportationFormModal} sendInfoFromChild={handleTransportationInfoFromChild} />
            }
        </div>
    )
}

export default OrderAgain;